import { useTheme } from '@emotion/react';
import {
  Box,
  Button,
  Dialog,
  Divider,
  Grid,
  MenuItem,
  Popover,
  TextField,
  Typography,
  useMediaQuery,
  Stack,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  IconButton,
} from '@mui/material';
import ClearIcon from '@mui/icons-material/Clear';
import Paper from '@mui/material/Paper';
import { Moxoseparationinlisting, postApiCall } from 'api/apiService';
import { Pendingwarning } from 'component/BuyersMarketplace/MakeOffers';
import {
  ADD_BUYERSTAGE2,
  CONTRACT_APPROVE,
  SHARE_WINNER,
  BINDER_FOR_CONTRACT,
  CONTRACT_FILE_UPLOAD,
} from 'constant/app.config';
import React, { useContext, useEffect, useRef, useState } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import Swal from 'sweetalert2';
import { poppins400, poppins500 } from 'theme/common.style';
import { BuyerFound } from '../BuyerRegistration';
import ManageOffer from '../ManageOffer';
import { ToggleOff } from 'component/ContactTab/ContactTab';
import { ToggleOn } from 'component/OwnerCard/OwnerCard';
import PdfIcon from 'assets/images/pdficon.png';
import dayjs from 'dayjs';
import utc from 'dayjs/plugin/utc';
import timezone from 'dayjs/plugin/timezone';
import BroadcastMessagepopup from './BroadcastMessagepopup';
import ForwardCounterOfferPopup from 'component/VendorStatusContainer/ForwardCounterOfferPopup';
import { PropertyContext } from 'component/PropertyContext/PropertyContext';
import Loading from 'assets/images/loading.png';
import ActionDrawer from './ActionDrawer';
import Requestdeposit from './RequestDepositPopup';
import DetailsPopup from 'component/VendorStatusContainer/DepositManager/StatusDetailsPopups/DetailsPopup';
import ShareOfferWithMarketPlace from 'component/BuyerRegistration/ShareOfferWithMarketPlace';
import { datacontext } from 'modules/AppLayout/AppLayout';
import FinalContractUploadDialog from './FinalContractUploadDialog';
import PrepareContractSignDialog from './PrepareContractSignDialog';
import ViewCommenceEsignPdf from 'component/BuyersMarketplace/ViewCommenceEsignPdf';
import ActionNotificationSettingPopup from './ActionNotificationSettingPopup';

dayjs.extend(utc);
dayjs.extend(timezone);

export const SignContract = ({ color = '#000000' }) => {
  return (
    <svg
      width="30"
      height="30"
      viewBox="0 0 30 30"
      fill={color}
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M11.1291 12.6786C11.1291 12.3984 11.3159 12.2115 11.5961 12.2115H17.5742C17.8544 12.2115 18.0412 12.3984 18.0412 12.6786C18.0412 12.9588 17.8544 13.1456 17.5742 13.1456H11.5961C11.3626 13.1456 11.1291 12.9588 11.1291 12.6786ZM11.5961 15.9478H17.5742C17.8544 15.9478 18.0412 15.761 18.0412 15.4808C18.0412 15.2005 17.8544 15.0137 17.5742 15.0137H11.5961C11.3159 15.0137 11.1291 15.2005 11.1291 15.4808C11.1291 15.761 11.3626 15.9478 11.5961 15.9478ZM11.5961 18.7033H15.1456C15.4258 18.7033 15.6126 18.5165 15.6126 18.2363C15.6126 17.956 15.4258 17.7692 15.1456 17.7692H11.5961C11.3159 17.7692 11.1291 17.956 11.1291 18.2363C11.1291 18.4698 11.3626 18.7033 11.5961 18.7033ZM25 15.6676C25 15.9011 24.9066 16.1346 24.7198 16.3214L18.4615 22.4863C18.3681 22.5797 18.2747 22.6264 18.1813 22.6731L15.6593 23.7006C15.5659 23.7473 15.1456 23.8874 14.772 23.5137C14.5385 23.2802 14.445 22.9533 14.5852 22.6264L15.5659 20.1044C15.6126 20.011 15.6593 19.9176 15.7527 19.8242L20.2363 15.3874V9.73626H17.761C17.4808 9.73626 17.294 9.54945 17.294 9.26923V6.93406H9.54121C9.21429 6.93406 8.93407 7.21428 8.93407 7.5412V20.805C8.93407 21.1319 9.21429 21.4121 9.54121 21.4121H12.9973C13.2775 21.4121 13.4643 21.5989 13.4643 21.8791C13.4643 22.1593 13.2775 22.3462 12.9973 22.3462H9.54121C8.70055 22.3462 8 21.6456 8 20.805V7.5412C8 6.70055 8.70055 6 9.54121 6H17.761C17.9478 6 18.0412 6.09341 18.0879 6.14011L21.0302 8.9423C21.1703 9.08241 21.1703 9.26923 21.1703 9.26923V14.4533L22.011 13.6126C22.3846 13.239 22.9451 13.239 23.3187 13.6126L24.7198 15.0137C24.9066 15.2005 25 15.3874 25 15.6676ZM18.228 8.80219H19.5357L19.3022 8.56868L18.228 7.5412V8.80219ZM17.294 22.0192L16.2665 20.9451L15.5659 22.7198L17.294 22.0192ZM24.0659 15.6209L22.6648 14.2665L16.7802 20.1511L18.1346 21.5522L24.0659 15.6209Z"
        fill={color}
      />
    </svg>
  );
};

const Warning = () => {
  return (
    <svg
      width="38"
      height="36"
      viewBox="0 0 38 36"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <rect
        width="37.5797"
        height="36"
        rx="18"
        fill="#10D35E"
        fill-opacity="0.1"
      />
      <path
        d="M27.0817 21.4607L21.3085 11.456C20.7883 10.5551 19.8271 10 18.7866 10C17.7462 10 16.7851 10.5551 16.2648 11.456L10.3902 21.632C9.86994 22.5329 9.86994 23.6431 10.3902 24.544C10.9104 25.4449 11.8715 26 12.912 26H24.6614C24.6646 26 24.6677 26 24.6677 26C26.276 26 27.5797 24.6962 27.5797 23.088C27.5797 22.4853 27.3957 21.9239 27.0817 21.4607ZM20.0333 22.4345C20.0333 23.1229 19.5036 23.6495 18.7898 23.6495C18.0761 23.6495 17.5464 23.1229 17.5464 22.4345V22.406C17.5464 21.7208 18.0761 21.1911 18.7898 21.1911C19.5036 21.1911 20.0333 21.7177 20.0333 22.406V22.4345ZM20.0619 14.2443L19.4465 19.6178C19.4052 20.0048 19.1483 20.2458 18.7898 20.2458C18.4314 20.2458 18.1745 20.0016 18.1332 19.6178L17.5178 14.2411C17.4766 13.8255 17.7019 13.5115 18.0888 13.5115H19.4877C19.8747 13.5147 20.1031 13.8287 20.0619 14.2443Z"
        fill="#10D35E"
      />
    </svg>
  );
};
export const OpenIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 39 38"
      fill="none"
    >
      <path
        d="M37.7863 19.1323C37.7863 9.03333 29.5995 0.846539 19.5006 0.846539C9.40164 0.846539 1.21484 9.03333 1.21484 19.1323C1.21484 29.2312 9.40164 37.418 19.5006 37.418C29.5995 37.418 37.7863 29.2312 37.7863 19.1323Z"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M19.5006 17.3465C19.9094 17.3465 20.36 17.5559 20.7184 17.9143C21.0768 18.2727 21.2863 18.7234 21.2863 19.1322C21.2863 19.5409 21.0769 19.9908 20.7187 20.3485C20.3605 20.7061 19.9098 20.9152 19.5006 20.9152C19.0914 20.9152 18.6406 20.7061 18.2824 20.3485C17.9242 19.9908 17.7148 19.5409 17.7148 19.1322C17.7148 18.7234 17.9243 18.2727 18.2827 17.9143C18.6411 17.5559 19.0917 17.3465 19.5006 17.3465ZM19.5006 26.4893C19.9094 26.4893 20.36 26.6988 20.7184 27.0572C21.0768 27.4156 21.2863 27.8662 21.2863 28.275C21.2863 28.6837 21.0769 29.1336 20.7187 29.4913C20.3605 29.849 19.9098 30.0581 19.5006 30.0581C19.0914 30.0581 18.6406 29.849 18.2824 29.4913C17.9242 29.1336 17.7148 28.6837 17.7148 28.275C17.7148 27.8662 17.9243 27.4156 18.2827 27.0572C18.6411 26.6988 19.0917 26.4893 19.5006 26.4893ZM19.5006 8.20361C19.9094 8.20361 20.36 8.41305 20.7184 8.77145C21.0768 9.12985 21.2863 9.58051 21.2863 9.98933C21.2863 10.398 21.0769 10.8479 20.7187 11.2056C20.3605 11.5633 19.9098 11.7724 19.5006 11.7724C19.0914 11.7724 18.6406 11.5633 18.2824 11.2056C17.9242 10.8479 17.7148 10.398 17.7148 9.98933C17.7148 9.58051 17.9243 9.12985 18.2827 8.77145C18.6411 8.41305 19.0917 8.20361 19.5006 8.20361Z"
        fill="black"
        stroke="#6C2AD2"
      />
    </svg>
  );
};
const CloseIcon = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="30"
      height="30"
      viewBox="0 0 39 38"
      fill="none"
    >
      <path
        d="M19.5006 37.4181C29.5995 37.4181 37.7863 29.2313 37.7863 19.1324C37.7863 9.03347 29.5995 0.84668 19.5006 0.84668C9.40164 0.84668 1.21484 9.03347 1.21484 19.1324C1.21484 29.2313 9.40164 37.4181 19.5006 37.4181Z"
        stroke="#6C2AD2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M21.2859 19.1324C21.2859 19.5412 21.0764 19.9919 20.718 20.3503C20.3596 20.7087 19.909 20.9181 19.5001 20.9181C19.0914 20.9181 18.6415 20.7088 18.2839 20.3505C17.9262 19.9923 17.7171 19.5416 17.7171 19.1324C17.7171 18.7232 17.9262 18.2725 18.2839 17.9142C18.6415 17.556 19.0914 17.3467 19.5001 17.3467C19.909 17.3467 20.3596 17.5561 20.718 17.9145C21.0764 18.2729 21.2859 18.7236 21.2859 19.1324ZM12.143 19.1324C12.143 19.5412 11.9336 19.9919 11.5752 20.3503C11.2168 20.7087 10.7661 20.9181 10.3573 20.9181C9.94859 20.9181 9.49869 20.7088 9.14101 20.3505C8.78333 19.9923 8.57422 19.5416 8.57422 19.1324C8.57422 18.7232 8.78333 18.2725 9.14101 17.9142C9.49869 17.556 9.94859 17.3467 10.3573 17.3467C10.7661 17.3467 11.2168 17.5561 11.5752 17.9145C11.9336 18.2729 12.143 18.7236 12.143 19.1324ZM30.4287 19.1324C30.4287 19.5412 30.2193 19.9919 29.8609 20.3503C29.5025 20.7087 29.0518 20.9181 28.643 20.9181C28.2343 20.9181 27.7844 20.7088 27.4267 20.3505C27.069 19.9923 26.8599 19.5416 26.8599 19.1324C26.8599 18.7232 27.069 18.2725 27.4267 17.9142C27.7844 17.556 28.2343 17.3467 28.643 17.3467C29.0518 17.3467 29.5025 17.5561 29.8609 17.9145C30.2193 18.2729 30.4287 18.7236 30.4287 19.1324Z"
        fill="black"
        stroke="#6C2AD2"
      />
    </svg>
  );
};
const Invite = () => {
  return (
    <svg
      xmlns="http://www.w3.org/2000/svg"
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
    >
      <path
        d="M4.42857 0V5.86207M13.5714 0V5.86207M3.85714 8.7931H7.28571M14.1429 8.7931H10.7143M3.85714 12.3103H7.28571M10.7143 12.3103H14.1429M2.14286 2.93103H15.8571C16.4883 2.93103 17 3.45595 17 4.10345V15.8276C17 16.4751 16.4883 17 15.8571 17H2.14286C1.51168 17 1 16.4751 1 15.8276V4.10345C1 3.45595 1.51167 2.93103 2.14286 2.93103Z"
        stroke="#9401B9"
      />
    </svg>
  );
};
const Offer = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.33233 7.80887L5.33168 7.82033C5.28733 8.5971 5.72244 9.32479 6.44047 9.67366L6.44784 9.67726C6.70098 9.79835 6.90847 9.99798 7.03938 10.2462L7.04232 10.2516C7.40412 10.9405 8.15242 11.3581 8.95015 11.3162L8.96226 11.3156C9.25156 11.2994 9.53874 11.374 9.78354 11.5291C10.459 11.9516 11.3165 11.9516 11.992 11.5291C12.2368 11.374 12.5239 11.2994 12.8133 11.3156L12.8254 11.3162C13.6218 11.3584 14.3711 10.9405 14.7337 10.2505L14.7355 10.2467C14.8669 9.99782 15.0749 9.79786 15.3288 9.67661L15.3347 9.67366C16.0527 9.32463 16.488 8.5971 16.4435 7.82016L16.4428 7.80936C16.4281 7.53576 16.504 7.26495 16.6592 7.03897C17.1057 6.3877 17.1057 5.52894 16.6593 4.87751C16.5044 4.65169 16.4281 4.38104 16.4428 4.10744L16.4435 4.09599C16.488 3.31905 16.0527 2.59152 15.3341 2.24233L15.3275 2.23905C15.0749 2.11829 14.8679 1.91964 14.7368 1.67206L14.733 1.66469C14.3711 0.975788 13.6218 0.558355 12.8254 0.600082L12.8131 0.600736C12.5239 0.616936 12.2368 0.542319 11.9921 0.387192H11.9918C11.3163 -0.0353141 10.4589 -0.0353141 9.78338 0.387192C9.53858 0.542155 9.2514 0.616773 8.96209 0.600573L8.94998 0.599918C8.15341 0.5577 7.40428 0.975625 7.04249 1.66437L7.0397 1.66944C6.90863 1.91816 6.70098 2.11796 6.44751 2.23922L6.44064 2.24249C5.7226 2.59136 5.28733 3.31905 5.33184 4.09599L5.3325 4.10679C5.34722 4.38038 5.2713 4.6512 5.11617 4.87702C4.66961 5.52845 4.66961 6.38737 5.11617 7.03864C5.27113 7.26446 5.34722 7.53527 5.33233 7.80887ZM5.66779 5.25763C5.90718 4.90909 6.02451 4.49117 6.0016 4.06899L6.00095 4.05753C5.97738 3.54274 6.26636 3.06459 6.73289 2.84581L6.73862 2.84303C7.12136 2.65976 7.43472 2.35802 7.63239 1.98264L7.63566 1.97642C7.87604 1.51857 8.37955 1.24104 8.91431 1.26951L8.92609 1.27C9.354 1.29406 9.77863 1.18377 10.1406 0.954352C10.5976 0.668481 11.1776 0.668481 11.6346 0.954352C11.9965 1.18344 12.4212 1.2939 12.8489 1.27017L12.8607 1.26951C13.3981 1.24137 13.8991 1.51857 14.1389 1.97511L14.1433 1.98345C14.341 2.35834 14.654 2.6596 15.0362 2.8427L15.0418 2.84549C15.5157 3.07588 15.8034 3.55157 15.7744 4.0577L15.7737 4.06964C15.7508 4.49182 15.8683 4.90958 16.1077 5.25812C16.397 5.68014 16.3969 6.2365 16.1074 6.65835C15.8682 7.00706 15.7508 7.42498 15.7737 7.84716L15.7744 7.85845C15.8034 8.36458 15.5157 8.84043 15.0416 9.07099L15.0367 9.07328C14.6537 9.25688 14.34 9.55895 14.1421 9.93499L14.1397 9.93989C13.8991 10.3977 13.3964 10.6754 12.8609 10.6468L12.8492 10.6461C12.4213 10.6223 11.9965 10.7327 11.6344 10.962C11.1776 11.2477 10.5976 11.2477 10.1408 10.962C9.81152 10.7533 9.4296 10.6427 9.03982 10.643C9.00202 10.643 8.96406 10.644 8.92609 10.6461L8.91431 10.6466C8.38659 10.6802 7.88734 10.404 7.63517 9.93908L7.63174 9.93269C7.43439 9.55797 7.12152 9.25688 6.73943 9.07377L6.73322 9.07066C6.25916 8.84027 5.97149 8.36441 6.00062 7.85845L6.00127 7.84651C6.02402 7.42433 5.90653 7.0064 5.66729 6.65802C5.37815 6.23601 5.37831 5.67965 5.66779 5.25796V5.25763Z"
        fill="#2F3F5E"
      />
      <path
        d="M12.5512 7.05174C12.5512 7.31841 12.4846 7.56908 12.3512 7.80374C12.2232 8.03841 12.0312 8.23574 11.7752 8.39574C11.5246 8.55574 11.2259 8.65174 10.8792 8.68374V9.33174H10.3592V8.68374C9.85789 8.63574 9.45255 8.47841 9.14322 8.21174C8.83389 7.94508 8.67922 7.59308 8.67922 7.15574H9.65522C9.67122 7.36374 9.73789 7.53708 9.85522 7.67574C9.97255 7.80908 10.1406 7.89441 10.3592 7.93174V6.17174C10.0019 6.08108 9.71122 5.99041 9.48722 5.89974C9.26322 5.80374 9.07122 5.65441 8.91122 5.45174C8.75655 5.24908 8.67922 4.97174 8.67922 4.61974C8.67922 4.17708 8.83389 3.81174 9.14322 3.52374C9.45255 3.23041 9.85789 3.05974 10.3592 3.01174V2.36374H10.8792V3.01174C11.3486 3.05441 11.7246 3.20374 12.0072 3.45974C12.2952 3.71041 12.4579 4.05708 12.4952 4.49974H11.5192C11.5032 4.33441 11.4392 4.18774 11.3272 4.05974C11.2152 3.92641 11.0659 3.83574 10.8792 3.78774V5.51574C11.2366 5.60108 11.5272 5.69174 11.7512 5.78774C11.9752 5.87841 12.1646 6.02508 12.3192 6.22774C12.4739 6.42508 12.5512 6.69974 12.5512 7.05174ZM9.60722 4.57174C9.60722 4.79041 9.67122 4.96108 9.79922 5.08374C9.93255 5.20641 10.1192 5.30508 10.3592 5.37974V3.76374C10.1299 3.79041 9.94589 3.87308 9.80722 4.01174C9.67389 4.15041 9.60722 4.33708 9.60722 4.57174ZM10.8792 7.93174C11.1139 7.89441 11.2979 7.80108 11.4312 7.65174C11.5646 7.49708 11.6312 7.31308 11.6312 7.09974C11.6312 6.88641 11.5646 6.72108 11.4312 6.60374C11.3032 6.48108 11.1192 6.38241 10.8792 6.30774V7.93174Z"
        fill="#2F3F5E"
      />
      <path
        d="M17.9565 13.1953C17.5127 12.4077 16.5286 12.1078 15.7211 12.5139L13.0959 13.7543C12.7334 13.0803 12.0381 12.6512 11.273 12.6296L8.84953 12.5629C8.4658 12.5519 8.08928 12.4545 7.7481 12.2785L7.5015 12.1507C6.23889 11.4925 4.73394 11.4942 3.47263 12.1549L3.48802 11.5963C3.49309 11.4112 3.34729 11.2571 3.16222 11.252L0.50478 11.1788C0.319708 11.1738 0.165727 11.3196 0.160655 11.5046L0.000128454 17.3364C-0.00494426 17.5215 0.140855 17.6757 0.325926 17.6807L2.98336 17.7539H2.99269C3.17416 17.7537 3.32258 17.6092 3.32765 17.4279L3.33518 17.1489L4.02556 16.7793C4.29654 16.6335 4.6135 16.5988 4.90952 16.6825L9.03198 17.8396C9.03918 17.8417 9.04638 17.8434 9.05374 17.845C9.35172 17.9074 9.65543 17.9386 9.95996 17.9385C10.6047 17.9388 11.2419 17.7999 11.8279 17.5308C11.8423 17.5243 11.8562 17.5168 11.8694 17.5083L17.8467 13.6417C17.9958 13.5455 18.0439 13.3496 17.9565 13.1953ZM0.679379 17.0198L0.821414 11.8583L2.80893 11.9129L2.66673 17.0746L0.679379 17.0198ZM11.5258 16.9319C10.7978 17.2605 9.98467 17.3512 9.20216 17.1911L5.09066 16.0373C4.62806 15.9064 4.13258 15.9608 3.70925 16.1884L3.35645 16.3772L3.45103 12.9453C4.56883 12.2017 6.0026 12.1253 7.19321 12.7456L7.43981 12.8734C7.87082 13.096 8.34635 13.2189 8.8312 13.2328L11.2546 13.2996C11.9354 13.319 12.5135 13.8037 12.6516 14.4707L9.0418 14.3714C8.85673 14.3663 8.70275 14.5121 8.69767 14.6972C8.6926 14.8822 8.8384 15.0364 9.02347 15.0415L13.0072 15.1511H13.0167C13.198 15.1509 13.3464 15.0064 13.3515 14.8251C13.3556 14.6795 13.3446 14.5337 13.3191 14.3903L16.0112 13.1181L16.019 13.1143C16.401 12.9209 16.8629 12.9855 17.1769 13.2763L11.5258 16.9319Z"
        fill="#2F3F5E"
      />
      <defs>
        <clipPath id="clip0_25220_146903">
          <rect width="18" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardOff = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
        fill="#2F3F5E"
      />

      <defs>
        <clipPath id="clip0_25220_146922">
          <rect width="18" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const ForwardOffGray = () => {
  return (
    <svg
      width="18"
      height="17"
      viewBox="0 0 18 17"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25220_146961)">
        <path
          d="M10.25 10.4361H8.65C7.33768 10.4356 6.05019 10.774 4.9267 11.4145C3.80322 12.055 2.88648 12.9734 2.2756 14.0703C2.25843 13.8667 2.24989 13.6626 2.25 13.4583C2.25 9.2854 5.8316 5.90278 10.25 5.90278V2.125L18.25 8.16944L10.25 14.2139V10.4361Z"
          fill="#2F3F5E"
        />
      </g>
      <defs>
        <clipPath id="clip0_25220_146961">
          <rect width="18" height="17" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const Share = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        fill-rule="evenodd"
        clip-rule="evenodd"
        d="M17.4996 4.81236C17.4997 5.42745 17.3146 6.02831 16.9683 6.53669C16.6221 7.04507 16.1308 7.43741 15.5584 7.6626C14.986 7.8878 14.3591 7.93542 13.7592 7.79926C13.1594 7.66311 12.6145 7.34948 12.1954 6.89923L7.7224 9.54261C7.92718 10.1643 7.92718 10.8354 7.7224 11.4571L12.1954 14.1005C12.7104 13.5483 13.4113 13.2058 14.1634 13.1388C14.9156 13.0718 15.6659 13.2851 16.2704 13.7376C16.8749 14.1902 17.2909 14.8501 17.4385 15.5906C17.5861 16.3312 17.4549 17.1001 17.0701 17.7498C16.6853 18.3995 16.074 18.8842 15.3537 19.1107C14.6334 19.3372 13.8547 19.2896 13.1674 18.9771C12.48 18.6645 11.9323 18.109 11.6295 17.4172C11.3267 16.7255 11.2902 15.9463 11.5269 15.2292L7.0539 12.5867C6.63481 13.0369 6.0899 13.3504 5.49013 13.4864C4.89036 13.6225 4.26351 13.5749 3.6912 13.3497C3.11889 13.1245 2.62764 12.7322 2.2814 12.2239C1.93517 11.7156 1.75 11.1149 1.75 10.4999C1.75 9.88484 1.93517 9.28407 2.2814 8.77577C2.62764 8.26748 3.11889 7.8752 3.6912 7.65002C4.26351 7.42484 4.89036 7.37718 5.49013 7.51327C6.0899 7.64935 6.63481 7.96286 7.0539 8.41298L11.5269 5.76961C11.389 5.3488 11.344 4.90398 11.395 4.4641C11.4461 4.02423 11.5918 3.60065 11.8224 3.22257C12.0529 2.84449 12.3627 2.5209 12.7304 2.27411C13.098 2.02732 13.5148 1.86319 13.9521 1.79305C14.3893 1.72292 14.8365 1.74843 15.263 1.86784C15.6894 1.98725 16.0848 2.19771 16.422 2.48471C16.7593 2.77172 17.0302 3.12844 17.2163 3.53028C17.4023 3.93213 17.499 4.36954 17.4996 4.81236ZM16.1871 4.81236C16.1871 5.27649 16.0028 5.72161 15.6746 6.0498C15.3464 6.37798 14.9013 6.56236 14.4371 6.56236C13.973 6.56236 13.5279 6.37798 13.1997 6.0498C12.8715 5.72161 12.6871 5.27649 12.6871 4.81236C12.6871 4.34823 12.8715 3.90311 13.1997 3.57492C13.5279 3.24673 13.973 3.06236 14.4371 3.06236C14.9013 3.06236 15.3464 3.24673 15.6746 3.57492C16.0028 3.90311 16.1871 4.34823 16.1871 4.81236ZM4.81215 12.2499C5.27628 12.2499 5.7214 12.0655 6.04958 11.7373C6.37777 11.4091 6.56215 10.964 6.56215 10.4999C6.56215 10.0357 6.37777 9.59061 6.04958 9.26242C5.7214 8.93423 5.27628 8.74986 4.81215 8.74986C4.34802 8.74986 3.9029 8.93423 3.57471 9.26242C3.24652 9.59061 3.06215 10.0357 3.06215 10.4999C3.06215 10.964 3.24652 11.4091 3.57471 11.7373C3.9029 12.0655 4.34802 12.2499 4.81215 12.2499ZM16.1871 16.1874C16.1871 16.6515 16.0028 17.0966 15.6746 17.4248C15.3464 17.753 14.9013 17.9374 14.4371 17.9374C13.973 17.9374 13.5279 17.753 13.1997 17.4248C12.8715 17.0966 12.6871 16.6515 12.6871 16.1874C12.6871 15.7232 12.8715 15.2781 13.1997 14.9499C13.5279 14.6217 13.973 14.4374 14.4371 14.4374C14.9013 14.4374 15.3464 14.6217 15.6746 14.9499C16.0028 15.2781 16.1871 15.7232 16.1871 16.1874Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};
const Hotspot = () => {
  return (
    <svg
      width="19"
      height="18"
      viewBox="0 0 19 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25220_146928)">
        <path
          d="M14.5102 1.87043C14.4095 1.78153 14.2763 1.73313 14.1387 1.73543C14.001 1.73773 13.8697 1.79055 13.7724 1.88276C13.6751 1.97497 13.6193 2.09938 13.6169 2.22976C13.6144 2.36015 13.6655 2.48634 13.7594 2.58174C14.4511 3.23531 14.9996 4.01196 15.3734 4.86705C15.7472 5.72214 15.9389 6.63879 15.9375 7.56431C15.9375 9.51036 15.1059 11.2705 13.7594 12.5462C13.6626 12.6411 13.6089 12.7682 13.6101 12.9001C13.6112 13.0321 13.667 13.1584 13.7655 13.2517C13.8639 13.3451 13.9972 13.3981 14.1365 13.3993C14.2757 13.4005 14.41 13.3498 14.5102 13.2582C15.3006 12.5112 15.9275 11.6237 16.3547 10.6466C16.782 9.66944 17.0013 8.62196 17 7.56431C17 5.34044 16.048 3.32661 14.5102 1.87043ZM3.24063 2.58174C3.33447 2.48634 3.38556 2.36015 3.38313 2.22976C3.3807 2.09938 3.32494 1.97497 3.22761 1.88276C3.13028 1.79055 2.99896 1.73773 2.86133 1.73543C2.7237 1.73313 2.5905 1.78153 2.4898 1.87043C1.69939 2.61737 1.07254 3.5049 0.645266 4.48204C0.217991 5.45917 -0.00129492 6.50665 5.75232e-06 7.56431C5.75232e-06 9.7875 0.952005 11.8013 2.4898 13.2582C2.5905 13.3471 2.7237 13.3955 2.86133 13.3932C2.99896 13.3909 3.13028 13.3381 3.22761 13.2459C3.32494 13.1536 3.3807 13.0292 3.38313 12.8988C3.38556 12.7685 3.33447 12.6423 3.24063 12.5469C2.54891 11.8933 2.00038 11.1166 1.62658 10.2616C1.25278 9.40647 1.06108 8.48982 1.06251 7.56431C1.06251 5.61825 1.89409 3.85741 3.24063 2.58174ZM5.74459 4.95391C5.83843 4.85851 5.88951 4.73232 5.88708 4.60193C5.88466 4.47155 5.8289 4.34714 5.73157 4.25493C5.63423 4.16272 5.50292 4.1099 5.36529 4.1076C5.22766 4.1053 5.09446 4.1537 4.99375 4.2426C4.53271 4.67838 4.16709 5.19617 3.9179 5.76621C3.66871 6.33625 3.54085 6.94731 3.54167 7.56431C3.54085 8.1813 3.66871 8.79236 3.9179 9.36241C4.16709 9.93245 4.53271 10.4502 4.99375 10.886C5.09399 10.9776 5.22821 11.0283 5.3675 11.0271C5.5068 11.0259 5.64002 10.9729 5.73847 10.8796C5.83692 10.7862 5.89273 10.6599 5.89387 10.528C5.89502 10.396 5.8414 10.2689 5.74459 10.174C5.38224 9.83162 5.09493 9.42472 4.89922 8.97672C4.7035 8.52873 4.60323 8.04848 4.60417 7.56363C4.60341 7.07901 4.70377 6.59902 4.89949 6.15127C5.0952 5.70352 5.3824 5.29616 5.74459 4.95391ZM12.0062 4.2426C11.9576 4.19315 11.899 4.15349 11.8338 4.12598C11.7686 4.09847 11.6983 4.08368 11.627 4.08249C11.5556 4.0813 11.4848 4.09373 11.4186 4.11904C11.3525 4.14435 11.2924 4.18203 11.2419 4.22982C11.1915 4.27761 11.1517 4.33454 11.125 4.39721C11.0983 4.45988 11.0852 4.527 11.0864 4.59458C11.0877 4.66216 11.1033 4.7288 11.1323 4.79054C11.1614 4.85227 11.2032 4.90784 11.2554 4.95391C11.6178 5.29632 11.9051 5.70322 12.1008 6.15122C12.2965 6.59922 12.3968 7.07946 12.3958 7.56431C12.3967 8.04904 12.2964 8.52916 12.1006 8.97703C11.9049 9.42491 11.6177 9.8317 11.2554 10.174C11.2032 10.2201 11.1614 10.2757 11.1323 10.3374C11.1033 10.3991 11.0877 10.4658 11.0864 10.5334C11.0852 10.6009 11.0983 10.6681 11.125 10.7307C11.1517 10.7934 11.1915 10.8503 11.2419 10.8981C11.2924 10.9459 11.3525 10.9836 11.4186 11.0089C11.4848 11.0342 11.5556 11.0466 11.627 11.0455C11.6983 11.0443 11.7686 11.0295 11.8338 11.002C11.899 10.9745 11.9576 10.9348 12.0062 10.8853C12.4672 10.4496 12.8328 9.93196 13.082 9.36204C13.3312 8.79212 13.4591 8.18118 13.4583 7.56431C13.4591 6.94743 13.3312 6.33649 13.082 5.76657C12.8328 5.19665 12.4672 4.6783 12.0062 4.2426ZM9.91667 7.56431C9.9168 7.83176 9.83259 8.09314 9.67483 8.31494C9.51707 8.53673 9.29296 8.70881 9.03125 8.80911V14.4426C9.03125 14.5761 8.97528 14.7041 8.87565 14.7985C8.77602 14.8929 8.6409 14.9459 8.5 14.9459C8.3591 14.9459 8.22398 14.8929 8.12435 14.7985C8.02472 14.7041 7.96875 14.5761 7.96875 14.4426V8.80911C7.73049 8.7178 7.52294 8.56681 7.36833 8.37231C7.21372 8.17781 7.11788 7.94712 7.09107 7.70497C7.06425 7.46281 7.10748 7.2183 7.21612 6.99764C7.32476 6.77698 7.49471 6.58847 7.70778 6.45231C7.92085 6.31615 8.169 6.23747 8.42566 6.22469C8.68232 6.21191 8.93781 6.26552 9.16477 6.37978C9.39173 6.49403 9.5816 6.66463 9.71406 6.87329C9.84651 7.08195 9.91654 7.32082 9.91667 7.56431Z"
          fill="#2F3F5E"
        />
      </g>
      <defs>
        <clipPath id="clip0_25220_146928">
          <rect width="19" height="18" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const Confirm = () => {
  return (
    <svg
      width="18"
      height="18"
      viewBox="0 0 18 18"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M5.39922 8.4H4.79922V9.6H5.39922V8.4ZM12.5992 9.6H13.1992V8.4H12.5992V9.6ZM5.39922 4.8H4.79922V6H5.39922V4.8ZM7.79922 6H8.39922V4.8H7.79922V6ZM12.5992 0.6L13.0235 0.175736L12.8477 0H12.5992V0.6ZM16.1992 4.2H16.7992V3.95147L16.6235 3.77574L16.1992 4.2ZM8.99922 13.8L9.26755 14.3366L9.31593 14.3125L9.35922 14.28L8.99922 13.8ZM5.39922 9.6H12.5992V8.4H5.39922V9.6ZM5.39922 6H7.79922V4.8H5.39922V6ZM14.9992 16.8H2.99922V18H14.9992V16.8ZM2.39922 16.2V1.8H1.19922V16.2H2.39922ZM2.99922 1.2H12.5992V0H2.99922V1.2ZM15.5992 4.2V16.2H16.7992V4.2H15.5992ZM12.1749 1.02426L15.7749 4.62426L16.6235 3.77574L13.0235 0.175736L12.1749 1.02426ZM2.99922 16.8C2.66785 16.8 2.39922 16.5313 2.39922 16.2H1.19922C1.19922 17.1941 2.0051 18 2.99922 18V16.8ZM14.9992 18C15.9933 18 16.7992 17.1941 16.7992 16.2H15.5992C15.5992 16.5313 15.3305 16.8 14.9992 16.8V18ZM2.39922 1.8C2.39922 1.46863 2.66785 1.2 2.99922 1.2V0C2.0051 0 1.19922 0.805889 1.19922 1.8H2.39922ZM6.56843 13.9897C6.70179 13.5896 7.08026 13.2197 7.56489 13.0895C8.01679 12.968 8.59844 13.0477 9.17496 13.6243L10.0235 12.7757C9.16001 11.9123 8.14165 11.6919 7.25354 11.9305C6.39817 12.1603 5.69664 12.8104 5.43001 13.6103L6.56843 13.9897ZM9.17496 13.6243C9.21411 13.6634 9.24482 13.6985 9.26873 13.7293L10.2163 12.993C10.1585 12.9186 10.094 12.8462 10.0235 12.7757L9.17496 13.6243ZM9.26873 13.7293C9.36267 13.8502 9.34171 13.8878 9.34477 13.8619C9.34682 13.8444 9.3525 13.8715 9.28032 13.9372C9.20759 14.0033 9.08966 14.0758 8.93262 14.1395C8.7788 14.202 8.61133 14.2463 8.45973 14.2692C8.29949 14.2934 8.19655 14.2879 8.15963 14.2806C8.1389 14.2765 8.18109 14.2801 8.24229 14.3251C8.32001 14.3822 8.41736 14.5027 8.4251 14.6762C8.42835 14.7494 8.41367 14.8066 8.40056 14.8418C8.38779 14.8762 8.3747 14.895 8.37282 14.8976C8.37095 14.9003 8.39081 14.873 8.4596 14.8174C8.5962 14.707 8.84772 14.5465 9.26755 14.3366L8.73089 13.2634C8.27814 13.4897 7.93909 13.6951 7.70515 13.8842C7.58869 13.9784 7.47829 14.0844 7.39344 14.2042C7.31257 14.3184 7.21608 14.5006 7.22629 14.7296C7.23785 14.989 7.37855 15.1795 7.53139 15.292C7.66772 15.3922 7.81682 15.4361 7.92705 15.4578C8.15204 15.5023 8.40719 15.4908 8.63924 15.4558C9.09573 15.3866 9.68599 15.1902 10.0876 14.8249C10.2969 14.6346 10.4943 14.3609 10.5365 14.0021C10.5798 13.6348 10.4474 13.2904 10.2163 12.993L9.26873 13.7293ZM9.35922 14.28C9.57963 14.1146 9.7869 13.9957 9.98079 13.9118L9.50426 12.8105C9.21612 12.9352 8.92783 13.1035 8.63922 13.32L9.35922 14.28ZM9.98079 13.9118C10.7619 13.5738 11.4583 13.7525 12.1725 14.0926C12.3518 14.178 12.527 14.2711 12.7045 14.3671C12.8774 14.4607 13.06 14.5614 13.2338 14.6494C13.5638 14.8164 13.975 15 14.3992 15V13.8C14.287 13.8 14.102 13.7438 13.7757 13.5787C13.6214 13.5006 13.4609 13.4122 13.2758 13.3118C13.0951 13.214 12.8972 13.1086 12.6885 13.0092C11.8504 12.6101 10.7549 12.2694 9.50426 12.8105L9.98079 13.9118Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};
const Winner = () => {
  return (
    <svg
      width="22"
      height="22"
      viewBox="0 0 22 22"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5842 12.9359C13.9042 11.9239 15.8402 10.4279 15.8402 4.8399V4.3999H6.16016V4.8399C6.16016 10.4279 8.14016 11.9239 9.41616 12.9359C10.1642 13.5079 10.5602 13.8159 10.5602 14.5199V15.8399C9.85616 15.9279 9.15216 16.1919 8.88816 16.7199H7.92016C7.43616 16.7199 7.04016 17.1159 7.04016 17.5999H14.9602C14.9602 17.1159 14.5642 16.7199 14.0802 16.7199H13.1122C12.8482 16.1919 12.1882 15.9279 11.4402 15.8399V14.5199C11.4402 13.8159 11.7922 13.5079 12.5842 12.9359ZM11.0002 13.1559C10.7362 12.8039 10.3402 12.4959 9.98816 12.2319C8.80016 11.3079 7.17216 10.0759 7.08416 5.2799H15.0042C14.9162 10.0319 13.2882 11.3079 12.1002 12.2319C11.6602 12.5399 11.2642 12.8039 11.0002 13.1559Z"
        fill="#2F3F5E"
      />
      <path
        d="M8.27153 11.8798C8.22753 11.8798 3.51953 10.8678 3.51953 5.71979V5.27979H6.59953V6.15979H4.39953C4.66353 10.2078 8.40353 10.9998 8.44753 10.9998L8.27153 11.8798Z"
        fill="#2F3F5E"
      />
      <path
        d="M13.7268 11.8798L13.5508 10.9998C13.7268 10.9558 17.3348 10.1638 17.5988 6.15979H15.3988V5.27979H18.4788V5.71979C18.4788 10.8678 13.7708 11.8798 13.7268 11.8798Z"
        fill="#2F3F5E"
      />
    </svg>
  );
};
const Deposit = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clip-path="url(#clip0_25220_146936)">
        <path
          d="M16.362 8.44434H8.44531V9.49989H16.362V8.44434Z"
          fill="#2F3F5E"
        />
        <path
          d="M16.3602 11.0835H10.5547V12.1391H16.3602V11.0835Z"
          fill="#2F3F5E"
        />
        <path
          d="M17.944 4.22217H6.82373C7.00763 4.55458 7.14777 4.90937 7.24068 5.27772H17.4162V13.7222H1.5829V10.5027C1.19669 10.3228 0.840635 10.0842 0.527344 9.7955V14.2499C0.527344 14.3899 0.582949 14.5242 0.681926 14.6231C0.780904 14.7221 0.915146 14.7777 1.05512 14.7777H17.944C18.084 14.7777 18.2182 14.7221 18.3172 14.6231C18.4162 14.5242 18.4718 14.3899 18.4718 14.2499V4.74995C18.4718 4.60997 18.4162 4.47573 18.3172 4.37675C18.2182 4.27777 18.084 4.22217 17.944 4.22217Z"
          fill="#2F3F5E"
        />
        <path
          d="M5.72772 8.472C5.72772 8.728 5.66372 8.97333 5.53572 9.208C5.40772 9.43733 5.21839 9.62933 4.96772 9.784C4.72239 9.93867 4.42639 10.0267 4.07972 10.048V10.696H3.64772V10.048C3.16239 10.0053 2.76772 9.85067 2.46372 9.584C2.15972 9.312 2.00505 8.968 1.99972 8.552H2.77572C2.79705 8.776 2.87972 8.97067 3.02372 9.136C3.17305 9.30133 3.38105 9.40533 3.64772 9.448V7.448C3.29039 7.35733 3.00239 7.264 2.78372 7.168C2.56505 7.072 2.37839 6.92267 2.22372 6.72C2.06905 6.51733 1.99172 6.24533 1.99172 5.904C1.99172 5.472 2.14105 5.11467 2.43972 4.832C2.74372 4.54933 3.14639 4.392 3.64772 4.36V3.696H4.07972V4.36C4.53305 4.39733 4.89839 4.544 5.17572 4.8C5.45305 5.05067 5.61305 5.37867 5.65572 5.784H4.87972C4.85305 5.59733 4.77039 5.42933 4.63172 5.28C4.49305 5.12533 4.30905 5.024 4.07972 4.976V6.928C4.43172 7.01867 4.71705 7.112 4.93572 7.208C5.15972 7.29867 5.34639 7.44533 5.49572 7.648C5.65039 7.85067 5.72772 8.12533 5.72772 8.472ZM2.73572 5.864C2.73572 6.12533 2.81305 6.32533 2.96772 6.464C3.12239 6.60267 3.34905 6.71733 3.64772 6.808V4.96C3.37039 4.98667 3.14905 5.07733 2.98372 5.232C2.81839 5.38133 2.73572 5.592 2.73572 5.864ZM4.07972 9.456C4.36772 9.424 4.59172 9.32 4.75172 9.144C4.91705 8.968 4.99972 8.75733 4.99972 8.512C4.99972 8.25067 4.91972 8.05067 4.75972 7.912C4.59972 7.768 4.37305 7.65333 4.07972 7.568V9.456Z"
          fill="#2F3F5E"
        />
      </g>
      <defs>
        <clipPath id="clip0_25220_146936">
          <rect width="19" height="19" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};
const RequestIcon = () => {
  return (
    <svg
      width="21"
      height="21"
      viewBox="0 0 21 21"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M19.4062 19.2H18.3281C18.5437 18.475 18.6875 17.75 18.6875 17.025C18.6875 13.4 15.8125 10.5 12.2188 10.5C8.625 10.5 5.75 13.4 5.75 17.025C5.75 17.75 5.89375 18.475 6.10938 19.2H5.03125C4.6 19.2 4.3125 19.49 4.3125 19.925C4.3125 20.36 4.6 20.65 5.03125 20.65H13.5125H17.1781H19.3344C19.7656 20.65 20.0531 20.36 20.0531 19.925C20.0531 19.49 19.8375 19.2 19.4062 19.2ZM7.1875 17.025C7.1875 14.1975 9.41563 11.95 12.2188 11.95C15.0219 11.95 17.25 14.1975 17.25 17.025C17.25 17.75 17.1062 18.5475 16.7469 19.2H14.6625C14.6625 19.1275 14.6625 19.055 14.6625 18.9825C14.6625 17.895 13.8 17.025 12.7219 17.025H11.5C11.2125 17.025 10.9969 16.8075 10.9969 16.5175C10.9969 16.2275 11.2125 16.01 11.5 16.01H13.8719C14.3031 16.01 14.5906 15.72 14.5906 15.285C14.5906 14.85 14.3031 14.56 13.8719 14.56H12.9375V14.125C12.9375 13.69 12.65 13.4 12.2188 13.4C11.7875 13.4 11.5 13.69 11.5 14.125V14.6325C10.4938 14.705 9.70312 15.5025 9.70312 16.5175C9.70312 17.605 10.5656 18.475 11.6438 18.475H12.8656C13.1531 18.475 13.3688 18.6925 13.3688 18.9825C13.3688 19.055 13.3687 19.1275 13.2969 19.2H7.7625C7.33125 18.5475 7.1875 17.75 7.1875 17.025Z"
        fill="#112347"
      />
      <path
        d="M2.15625 11.9501C2.73125 11.9501 3.30625 11.7326 3.66562 11.2976C4.025 10.9351 4.24062 10.5001 4.3125 9.9926L5.75 10.3551C5.89375 10.4276 6.10938 10.4276 6.25312 10.4276C6.68437 10.4276 7.04375 10.2826 7.40313 10.0651L12.2188 7.0201L15.5969 9.8476C15.9563 10.1376 16.4594 10.3551 16.9625 10.3551C17.1063 10.3551 17.3219 10.3551 17.4656 10.2826L19.6219 9.7026C19.8375 9.6301 20.0531 9.4126 20.125 9.1951C20.1969 8.9776 20.125 8.6876 19.9094 8.4701L13.8719 2.3801C13.4406 2.0176 12.9375 1.8001 12.3625 1.8001H4.16875C3.88125 0.930098 3.09063 0.350098 2.15625 0.350098C0.934375 0.350098 0 1.2926 0 2.5251V9.7751C0 11.0076 0.934375 11.9501 2.15625 11.9501ZM12.8656 3.4676L18.0406 8.6876L17.1062 8.9051C16.8906 8.9776 16.675 8.9051 16.4594 8.7601L12.7219 5.6426C12.65 5.5701 12.65 5.5701 12.5781 5.5701C12.5781 5.5701 12.5781 5.5701 12.5062 5.5701C12.4344 5.4251 12.2906 5.4251 12.2188 5.4251H7.1875C6.75625 5.4251 6.46875 5.7151 6.46875 6.1501C6.46875 6.5851 6.75625 6.8751 7.1875 6.8751H9.70312L6.6125 8.8326C6.46875 8.9051 6.25312 8.9776 6.0375 8.9051L4.3125 8.4701V3.2501H12.3625C12.5063 3.2501 12.7219 3.3226 12.8656 3.4676ZM1.4375 2.5251C1.4375 2.0901 1.725 1.8001 2.15625 1.8001C2.5875 1.8001 2.875 2.0901 2.875 2.5251V9.0501V9.7751C2.875 9.9926 2.80312 10.1376 2.65937 10.2826C2.51562 10.4276 2.37188 10.5001 2.15625 10.5001C1.725 10.5001 1.4375 10.2101 1.4375 9.7751V2.5251Z"
        fill="#112347"
      />
    </svg>
  );
};
const Compare = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M13.2342 15.6369L12.7271 11.5804C12.5785 10.3919 11.5682 9.5 10.3705 9.5H9.49833H8.62615C7.42842 9.5 6.41809 10.3919 6.26952 11.5804L5.76246 15.6369C5.64433 16.5819 6.38119 17.4167 7.33356 17.4167H9.49833H11.6631C12.6154 17.4167 13.3523 16.5819 13.2342 15.6369Z"
        stroke="#C5C5C5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M9.5 6.3335C10.8117 6.3335 11.875 5.27017 11.875 3.9585C11.875 2.64682 10.8117 1.5835 9.5 1.5835C8.18832 1.5835 7.125 2.64682 7.125 3.9585C7.125 5.27017 8.18832 6.3335 9.5 6.3335Z"
        stroke="#C5C5C5"
      />
      <path
        d="M3.16536 8.70817C4.03982 8.70817 4.7487 7.99929 4.7487 7.12484C4.7487 6.25039 4.03982 5.5415 3.16536 5.5415C2.29091 5.5415 1.58203 6.25039 1.58203 7.12484C1.58203 7.99929 2.29091 8.70817 3.16536 8.70817Z"
        stroke="#C5C5C5"
      />
      <path
        d="M15.8333 8.70817C16.7078 8.70817 17.4167 7.99929 17.4167 7.12484C17.4167 6.25039 16.7078 5.5415 15.8333 5.5415C14.9589 5.5415 14.25 6.25039 14.25 7.12484C14.25 7.99929 14.9589 8.70817 15.8333 8.70817Z"
        stroke="#C5C5C5"
      />
      <path
        d="M3.16779 11.0835H2.92574C2.15175 11.0835 1.4912 11.643 1.36395 12.4065L1.10006 13.9899C0.939216 14.955 1.68345 15.8335 2.66185 15.8335H5.54279"
        stroke="#C5C5C5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M15.832 11.0835H16.074C16.8481 11.0835 17.5086 11.643 17.6358 12.4065L17.8998 13.9899C18.0606 14.955 17.3165 15.8335 16.3381 15.8335C15.4184 15.8335 14.3241 15.8335 13.457 15.8335"
        stroke="#C5C5C5"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
    </svg>
  );
};
const Message = () => {
  return (
    <svg
      width="19"
      height="19"
      viewBox="0 0 19 19"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M8.70703 11.875C11.082 11.875 15.0404 15.0417 15.0404 15.0417V2.375C15.0404 2.375 11.082 5.54167 8.70703 5.54167M8.70703 11.875V5.54167M8.70703 11.875H4.7487C3.00006 11.875 1.58203 11.1713 1.58203 8.70833C1.58203 6.24537 3.00006 5.54167 4.7487 5.54167H8.70703M3.95703 11.875L6.33203 18.2083H9.4987L7.1237 11.875M15.0404 11.0833C16.3522 11.0833 17.4154 10.0201 17.4154 8.70833C17.4154 7.39654 16.3522 6.33333 15.0404 6.33333M8.70703 15.0417C9.4987 15.0417 11.082 14.25 11.082 12.6667"
        stroke="#2F3F5E"
      />
    </svg>
  );
};
const NeedHelp = () => {
  return (
    <svg
      width="25"
      height="25"
      viewBox="0 0 25 25"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <path
        d="M12.5 21.875C17.6777 21.875 21.875 17.6777 21.875 12.5C21.875 7.32233 17.6777 3.125 12.5 3.125C7.32233 3.125 3.125 7.32233 3.125 12.5C3.125 17.6777 7.32233 21.875 12.5 21.875Z"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5 17.7085V17.7189"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />
      <path
        d="M12.5013 14.0627C12.4821 13.7246 12.5733 13.3893 12.7612 13.1075C12.9491 12.8257 13.2235 12.6126 13.543 12.5002C13.9345 12.3505 14.2859 12.1119 14.5696 11.8033C14.8533 11.4947 15.0614 11.1244 15.1777 10.7217C15.2939 10.3189 15.3151 9.89468 15.2396 9.48236C15.164 9.07004 14.9938 8.68089 14.7423 8.34554C14.4907 8.01019 14.1648 7.7378 13.7901 7.54982C13.4155 7.36183 13.0023 7.26338 12.5831 7.26222C12.1639 7.26105 11.7502 7.35721 11.3745 7.54312C10.9988 7.72902 10.6713 7.9996 10.418 8.33355"
        stroke="#EEAD06"
        stroke-width="2"
        stroke-linecap="round"
        stroke-linejoin="round"
      />

      <defs>
        <clipPath id="clip0_25220_146967">
          <rect width="25" height="25" fill="white" />
        </clipPath>
      </defs>
    </svg>
  );
};

export default function SelectMenu(props) {
  const {
    onShowChat,
    setOpenBox,
    openBox,
    setOfferUniqueId,
    setPaymentStatus,
    row,
    index,
    setOpenPublishWinnerBox,
    forwardtobuyer,
    setbuyerOfferPrice,
    buyerOfferPrice,
    selectedrowbuyerid,
    setSelectedrowbuyerid,
    setSelectedrowbuyername,
    selectedrowbuyername,
    setTableChecked,
    tableChecked,
    setForwardtobuyer,
    tableData,
    getListInfo,
    address,
    updatefunc,
    setUpdatefunc,
    isUnPublished,
    OfferCard,
    item,
    inActive,
    buyerRegisterChecked,
    setBuyerRegisterChecked,
    handleClick,
    setShowBackDrop,
    isCardSelected,
    buyerRegisterCheckBox,
    setBuyerRegisterCheckBox,
    buyerRegisterCheckBoxArr,
    userTypeValue,
    reqDepositOpen,
    setReqDepositOpen,
    offerUniqueId,
    campaignId,
    setOfferHistory,
    selectedCheckboxes,
    setSelectedCheckboxes,
    endPropertyPopupFromNominateWinner,
    setEndPropertyPopupFromNominateWinner,
    isAppraisalProperty,
    profileData,
    latestcounterOfferPrice,
    mobileView,
    propertyDetails,
    mobileTableData,
    setBuyerRegisterCheckBoxArr,
    sharedToMarket,
    setManageofferrow,
  } = props;
  const params = useParams();
  const history = useHistory();
  const formattedlatestcounterOfferPrice = latestcounterOfferPrice
    ? latestcounterOfferPrice.replace(/[$,]/g, '')
    : ' ';
  const shareBtnRaw = row?.buyerOfferDetails?.isFwdToBuyer || '[]';
  const offerPriceVendor = row?.buyerOfferDetails?.offerPriceVendor;
  const formattedOfferPriceVendor = offerPriceVendor
    ? `$${Number(offerPriceVendor).toLocaleString()}`
    : ' ';
  const shareBtn =
    typeof shareBtnRaw === 'string' ? JSON.parse(shareBtnRaw) : shareBtnRaw;
  const rowCount = tableData?.BuyerRegisterDetails?.length || 0;
  const shareBtnLength = Array.isArray(shareBtn) ? shareBtn.length : 0;
  const isDisabled = rowCount - shareBtnLength === 1;
  const counterOfferBuyerId = row?.buyerOfferDetails?.counterOfferBuyerId;
  const [selectedBuyerId, setSelectedBuyerId] = useState(null);
  const [forwardcountertobuyer, setForwardCountertobuyer] = useState(false);
  const userName =
    row?.buyerDetails?.user?.userName +
    ' ' +
    row?.buyerDetails?.user?.userSurName;

  const isInitialMount = useRef(true);

  useEffect(() => {
    if (!reqDepositOpen || !offerUniqueId) {
      setRequestdeposit(false);
      return;
    }

    if (reqDepositOpen == offerUniqueId) {
      setRequestdeposit(true);
    } else {
      setRequestdeposit(false);
    }
  }, [reqDepositOpen, offerUniqueId]);

  const offerIsFinal = row?.buyerOfferDetails?.offerIsFinal;
  const [manageOffer, setManageOffer] = useState(false);
  const [openhistorydialog, setOpenhistorydialog] = useState(false);
  const [anchorEl, setAnchorEl] = React.useState(null);
  const [shareMarketPlace, setShareMarketPlace] = React.useState(false);
  const [addbuyer, setAddbuyer] = React.useState(false);
  const [shareMarketPlaceLoader, setShareMarketPlaceLoader] =
    React.useState(false);
  const theme = useTheme();
  const matchessm = useMediaQuery(theme.breakpoints.down('sm'));
  const matches500 = useMediaQuery(theme.breakpoints.down(500));
  const matches400 = useMediaQuery(theme.breakpoints.down(600));
  const matches750 = useMediaQuery(theme.breakpoints.down(750));
  const matches700 = useMediaQuery(theme.breakpoints.down(700));
  const matches800 = useMediaQuery(theme.breakpoints.down(850));
  const matches900 = useMediaQuery(theme.breakpoints.down(900));
  const matchesmd = useMediaQuery(theme.breakpoints.down('md'));
  const [contractAprove, setContractAprove] = useState(false);
  const [requestdeposit, setRequestdeposit] = useState(false);
  const [depositdetails, setDepositdetails] = useState(false);
  const [depositRes, setDepositRes] = useState('');
  const [contractAppLoader, setContractAppLoader] = useState(false);
  const [loading, setLoading] = useState(false);
  const [sharewinner, setSharewinner] = useState(false);
  const [amount, setAmount] = useState(0);
  const [depositPercent, setDepositPercent] = useState();
  const [depositAmount, setDepositAmount] = useState();
  const [depositDue, setDepositDue] = useState();
  const [FromOgDate, setFromOgDate] = useState();
  const [depositSettlement, setDepositSettlement] = useState();
  const [percentDis, setPercentDis] = useState(false);
  const [amountDis, setAmountDis] = useState(false);
  const [depositAmtErr, setDepositAmtErr] = useState(false);
  const [depositDueErr, setDepositDueErr] = useState(false);
  const [depositSettleErr, setDepositSettleErr] = useState(false);
  const [trustAccountName, setTrustAccountName] = useState();
  const [trustAccountNameErr, setTrustAccountNameErr] = useState(false);
  const [bsb, setBsb] = useState();
  const [bsbErr, setBsbErr] = useState(false);
  const [accountNo, setAccountNo] = useState();
  const [accountNoErr, setAccountNoErr] = useState(false);
  const [openbroadcastMessage, setBroadcastMessage] = useState(false);
  const [multipleChkCounter, setMultipleChkCounter] = useState(false);
  const [openNotificationSettingPopup, setOpenNotificationSettingPopup] =
    useState(false);
  const [notificationAnchorEl, setNotificationAnchorEl] = useState(null);

  const handleNotificationClick = (event) => {
    if (event && event.currentTarget) {
      setNotificationAnchorEl(event.currentTarget);
    }
    setOpenNotificationSettingPopup((prev) => !prev);
  };

  const { setShowMessage, setMessagedata } = useContext(datacontext);

  useEffect(() => {
    if (buyerRegisterCheckBox?.length >= 2 && latestcounterOfferPrice != '$0') {
      setMultipleChkCounter(true);
    } else {
      setMultipleChkCounter(false);
    }
  }, [buyerRegisterCheckBox, latestcounterOfferPrice]);

  const [drawerOpen, setDrawerOpen] = useState(false);

  const isNotEmptyArray = (arr) =>
    Array.isArray(arr) &&
    arr.length > 0 &&
    !arr.every((item) => Array.isArray(item) && item.length === 0);

  const [formattedTotalAmount, setFormattedTotalAmount] = useState('');
  const [initiateSignloading, setInitiateSignloading] = useState(false);
  const data = localStorage.getItem('userDetail');
  const userDetail = JSON.parse(data);
  const Activityid = userDetail?.userId;
  const usermail = userDetail?.userEmail;
  const offerPrice = row?.buyerDetails?.buyerOffer?.offerPrice
    ? parseFloat(
        row?.buyerDetails?.buyerOffer?.offerPrice.replace(/[^0-9.-]+/g, '')
      )
    : 0;

  const handleSend = (message) => {
    setBroadcastMessage(false); // Close after sending
  };

  const getFileNameParts = (name) => {
    const lastDot = name.lastIndexOf('.');
    if (lastDot === -1) return { base: name, ext: '' };

    return {
      base: name.slice(0, lastDot),
      ext: name.slice(lastDot),
    };
  };

  const handleDepositPercentChange = (e) => {
    let value = e.target.value.replace('%', '');

    if (!/^\d*$/.test(value)) return;

    const percentValue = parseInt(value, 10);

    if (percentValue > 100) return;

    if (value && !isNaN(percentValue) && percentValue >= 0) {
      const depositAmountCalculated = (percentValue / 100) * offerPrice;

      if (isNaN(depositAmountCalculated)) {
        setFormattedTotalAmount('');
      } else {
        const formattedAmount = depositAmountCalculated.toLocaleString('en-US');
        setFormattedTotalAmount(formattedAmount);
        setDepositAmount(depositAmountCalculated);
      }
    } else {
      setFormattedTotalAmount('');
      setDepositAmount(0);
    }

    setDepositPercent(value);
  };

  const flexStyle = { display: 'flex', alignItems: 'center', gap: '15px' };
  const reqStyle = {
    fontFamily: 'poppins',
    color: '#666666',
    whiteSpace: matches400 ? 'nowrap' : 'wrap',
    fontSize: matches750 ? '14px' : '16px',
    width: '30%',
  };

  const openMessage = (userid, proid) => {
    setInitiateSignloading(true);
    if (tableData[index]?.contractBinderId != null) {
      handleOpenFinalContractDialog();
      setInitiateSignloading(false);
    } else {
      let parameters = {
        propertyId: params?.dashboardId,
        buyerId: userid,
      };
      postApiCall(BINDER_FOR_CONTRACT, parameters).then((res) => {
        if (res?.data?.binderId) {
          setInitiateSignloading(false);
          handleOpenFinalContractDialog();
        }
      });
    }
  };

  function formatInput(value) {
    let formattedValue = value.replace(/\D/g, ''); // Remove any non-digit characters
    if (formattedValue.length > 3) {
      formattedValue =
        formattedValue.slice(0, 3) + '-' + formattedValue.slice(3, 6);
    }
    return formattedValue;
  }

  function formatInputs(value) {
    let formattedValues = value.replace(/\D/g, ''); // Remove any non-digit characters
    if (formattedValues.length > 4) {
      // Insert hyphen after the first 4 digits
      formattedValues =
        formattedValues.slice(0, 4) + '-' + formattedValues.slice(4, 9);
    }
    return formattedValues;
  }

  const [open, setOpen] = useState(false);

  const handleIconClick = () => {
    setOpen(true);
  };

  useEffect(() => {
    if (depositPercent) {
      setAmountDis(true);
    } else {
      setAmountDis(false);
    }
  }, [depositPercent]);

  useEffect(() => {
    if (amount) {
      setPercentDis(true);
    } else {
      setPercentDis(false);
    }
  }, [amount]);

  const UserType = JSON.parse(localStorage.getItem('primaryUser'));
  const { setWinerPublishdMoveToEnded, setwinnerPopper } =
    useContext(PropertyContext);

  const userCategory = row?.buyerDetails?.userCategory;

  let isChecked = buyerRegisterCheckBox;

  const onPropertyClick = () => {
    let propertyId = params?.dashboardId;
    history.push({
      pathname: inActive
        ? `dashboard/viewinactive-dashboard/${item?.property?.propertyId}`
        : `/dashboard/view-dashboard/${item?.property?.propertyId}`,
    });
    window.scrollTo(0, 0);
  };

  const onDownload = () => {
    const link = document.createElement('a');
    link.download = `download.txt`;
    link.target = '_blank';
    window.open(item?.reportURL, '_blank');
    link.click();
    handleClosee();
  };

  const OpenContactApprove = () => {
    setContractAprove(true);
  };

  const colseContractAprove = () => {
    if (endPropertyPopupFromNominateWinner) {
      setWinerPublishdMoveToEnded(true);
    }
    setContractAprove(false);
    setRequestdeposit(false);
    setReqDepositOpen(false);
    setDepositAmtErr(false);
    setDepositDueErr(false);
    setDepositSettleErr(false);
    setDepositAmount('');
    setDepositPercent('');
    setAmount(0);
    setDepositDue(null);
    setFromOgDate(null);
    setDepositSettlement('');
  };

  const manageOfferClick = () => {
    setManageOffer(true);
  };

  const manageOfferClickClose = () => {
    setManageOffer(false);
    handleClosee();
  };

  const moxosepforwardOfferToBuyerFunc = (res) => {
    if (isNotEmptyArray(res?.dataForBuyerOfferSharingAck))
      Moxoseparationinlisting(
        'dataForBuyerOfferSharingAck',
        res?.dataForBuyerOfferSharingAck
      ); //1
    if (isNotEmptyArray(res?.dataForBuyerOffersAck))
      Moxoseparationinlisting(
        'dataForBuyerOffersAck',
        res?.dataForBuyerOffersAck
      ); //2
  };

  const addbuyerfunc = () => {
    setShareMarketPlaceLoader(true);
    let input = {};
    if (row?.buyerOfferDetails?.offerUniqueId) {
      input = {
        offerUniqueId: row?.buyerOfferDetails?.offerUniqueId,
        propertyId: params?.dashboardId,
        campaignId: campaignId,
      };
    } else {
      input = {
        offerUniqueId: row?.buyerDetails?.user?.userId,
        propertyId: params?.dashboardId,
        campaignId: campaignId,
      };
    }
    postApiCall(ADD_BUYERSTAGE2, input)
      .then((res) => {
        if (res?.data?.status == '1') {
          setShareMarketPlaceLoader(false);
          setAddbuyer(false);
          getListInfo();
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Success',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setShareMarketPlaceLoader(false);
          setAddbuyer(false);
          Swal.fire({
            title: res?.heading ? res?.heading : 'Error',
            text: res?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => setShareMarketPlaceLoader(false));
  };

  const [amendMedia, setAmendMedia] = useState([]);
  const [contractMedia, setContractMedia] = useState([]);

  const [amend, setAmend] = useState(false);
  const [contractSale, setContractSale] = useState(false);
  const [toggle, setToggle] = useState(false);
  const [firstName, setFirstName] = useState('');
  const [lastName, setLastName] = useState('');
  const [email, setEmail] = useState('');
  const [amendVal, setAmendVal] = useState(false);
  const [contractVal, setContractVal] = useState(false);
  const [firstVal, setFirstVal] = useState(false);
  const [lastVal, setLastVal] = useState(false);
  const [emailVal, setEmailVal] = useState(false);
  const [errorMessage, setErrorMessage] = useState('');
  const [errorAmendMessage, setErrorAmendMessage] = useState('');
  const [errorContractMessage, setErrorContractMessage] = useState('');

  function capitalize(str) {
    if (!str) return str;
    return str.charAt(0).toUpperCase() + str.slice(1).toLowerCase();
  }

  const handleEmail = (event) => {
    const email = event.target.value.toLowerCase(); // force lowercase
    setEmailVal(false);
    const emailPattern = /^[a-z0-9._%+-]+@[a-z0-9.-]+\.[a-z]{2,}$/; // only lowercase letters
    if (!emailPattern.test(email)) {
      setErrorMessage('Please enter a valid email address.');
    } else {
      setErrorMessage('');
    }

    setEmail(email);
  };

  useEffect(() => {
    if (toggle) {
      setFirstVal(false);
      setLastVal(false);
      setEmailVal(false);
      setFirstName('');
      setLastName('');
      setEmail('');
    }
  }, [toggle]);

  const uploadDocumentValidate = () => {
    let isValid = true;

    if (uploadDoc) {
      if (contractMedia.length < 1) {
        setContractVal(true);
        setErrorContractMessage('Please upload the contract of sale file.');
        isValid = false;
      } else {
        setContractVal(false);
        setErrorContractMessage('');
      }
    }

    if (!uploadDoc && !toggle) {
      setErrorContractMessage('');
      UpdatedContract();
      return;
    }

    const emailPattern = /^[A-Z0-9._%+-]+@[A-Z0-9.-]+\.[A-Z]{2,}$/i;

    if (toggle) {
      if (firstName == '') {
        setFirstVal(true);
        isValid = false;
      } else {
        setFirstVal(false);
      }

      if (lastName == '') {
        setLastVal(true);
        isValid = false;
      } else {
        setLastVal(false);
      }

      if (email == '') {
        setEmailVal(true);
        isValid = false;
      } else if (!emailPattern.test(email)) {
        setErrorMessage('Please enter a valid email address.');
        isValid = false;
      } else {
        setEmailVal(false);
        setErrorMessage('');
      }
    }
    if (isValid) {
      UpdatedContract();
    }
  };

  const cancelFunc = () => {
    setAmend(false);
    setContractSale(false);
    setToggle(false);
    setContractMedia([]);
    setAmendMedia([]);
    setAmendVal(false);
    setContractVal(false);
    setFirstVal(false);
    setLastVal(false);
    setEmailVal(false);
    setFirstName('');
    setLastName('');
    setEmail('');
    setErrorMessage('');
  };

  const UpdatedContract = async () => {
    setLoading(true);

    try {
      let propertyId = params?.dashboardId;
      let buyerId = props?.buyerId;

      const formData = new FormData();
      formData.append('buyerId', buyerId);
      formData.append('propertyId', propertyId);

      formData.append('legalName', firstName?.trim() || '');
      formData.append('legalLastName', lastName?.trim() || '');
      formData.append('legalEmail', email || '');

      if (amendMedia && amendMedia.length > 0) {
        amendMedia.forEach((file) => {
          formData.append('amendmentsContract', file.file || file);
        });
      } else {
        formData.append('amendmentsContract', '');
      }

      if (contractMedia && contractMedia.length > 0) {
        contractMedia.forEach((file) => {
          formData.append('approvedContract', file.file || file);
        });
      } else {
        formData.append('approvedContract', '');
      }

      formData.append('isSelf', toggle ? 0 : 1);

      const response = await postApiCall(CONTRACT_APPROVE, formData);

      const resData = response?.data || response;

      if (resData?.status == -1) {
        Swal.fire({
          title: resData?.heading || 'Error',
          text: resData?.message,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
      } else {
        setContractAprove(false);
        setAmendMedia([]);
        cancelFunc();

        Swal.fire({
          title: resData?.heading || 'Success',
          html: `An updated contract for <span style="font-weight: 550; font-family: 'Poppins'; color: #666666;">${selectedrowbuyername}</span> has been confirmed.`,
          showDenyButton: false,
          showCancelButton: false,
          icon: 'success',
          confirmButtonText: 'Close',
        });
      }
    } catch (error) {
      Swal.fire({
        title: 'Error',
        text:
          error?.response?.data?.message ||
          error?.message ||
          'Something went wrong. Please try again.',
        icon: 'error',
        confirmButtonText: 'Close',
      });
    } finally {
      setLoading(false);
    }
  };

  const handleAmendFileUpload = (event) => {
    if (!Array.isArray(amendMedia)) {
      setAmendMedia([]);
    }
    const selectedFiles = event.target.files;

    if (selectedFiles && selectedFiles.length > 0) {
      const newMedia = [...amendMedia];
      const newFormData = new FormData();

      for (let i = 0; i < selectedFiles.length; i++) {
        const file = selectedFiles[i];
        if (file.type !== 'application/pdf') {
          Swal.fire({
            title: 'Error',
            text: 'Please upload a PDF file',
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          return;
        } else if (file.size > 15e6) {
          Swal.fire({
            title: 'Error',
            text: 'Please upload a file smaller than 15 MB',
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          });
          return;
        } else {
          const fileWithCategory = {
            id: new Date().getTime() + i,
            name: file.name,
            type: file.type,
            size: file.size,
            category: 'Amendments',
            file: file,
          };
          newMedia.push(fileWithCategory);
          newFormData.append('files[]', file);
        }
      }

      setAmendMedia(newMedia);

      for (let pair of newFormData.entries()) {
        console.log(pair[0] + ': ' + pair[1]);
      }
    }
  };

  const handleContractFileUpload = (event) => {
    const selectedFiles = event.target.files;
    setErrorContractMessage('');
    if (selectedFiles && selectedFiles.length > 0) {
      const newFormData = new FormData();
      const file = selectedFiles[0];

      if (file.type !== 'application/pdf') {
        Swal.fire({
          title: 'Error',
          text: 'Please upload a PDF file',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
        return;
      } else if (file.size > 15e6) {
        Swal.fire({
          title: 'Error',
          text: 'Please upload a file smaller than 15 MB',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        });
        return;
      } else {
        const fileWithCategory = {
          id: new Date().getTime(),
          name: file.name,
          type: file.type,
          size: file.size,
          category: 'Contract of Sale',
          file: file,
        };

        setContractMedia([fileWithCategory]);
        newFormData.append('file', file);

        for (let pair of newFormData.entries()) {
          console.log(pair[0] + ': ' + pair[1]);
        }
      }
    }
  };

  const handleDeleteFile = (file) => {
    setAmendMedia(amendMedia.filter((f) => f !== file));
    setContractMedia(contractMedia.filter((f) => f !== file));
  };

  const moxoapis = (res) => {
    if (isNotEmptyArray(res?.data?.dataForDepositBuyerAck))
      Moxoseparationinlisting(
        'dataForDepositBuyerAck',
        res?.data?.dataForDepositBuyerAck
      ); //1
    if (isNotEmptyArray(res?.data?.dataForVendorAck))
      Moxoseparationinlisting('dataForVendorAck', res?.data?.dataForVendorAck); //2
  };

  const [selectedBuyerIdsForShare, setSelectedBuyerIdsForShare] = useState([]);

  const Sharewinnerfunc = () => {
    setContractAppLoader(true);

    const inputData = {
      buyerArr: selectedBuyerIdsForShare, // Use the saved IDs
      offerUniqueId: profileData?.PropertyDetails?.winnerOfferUniqueId,
    };

    postApiCall(SHARE_WINNER, inputData)
      .then((res) => {
        if (res?.data?.status == '1') {
          setContractAppLoader(false);
          setSharewinner(false);
          setBuyerRegisterCheckBox([]);
          setSelectedBuyerIdsForShare([]); // Clear the saved IDs
          Swal.fire({
            title: res?.data?.heading
              ? res?.data?.heading
              : 'Winner Details Shared',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'success',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        } else {
          setContractAppLoader(false);
          setSharewinner(false);
          setBuyerRegisterCheckBox([]);
          setSelectedBuyerIdsForShare([]); // Clear the saved IDs
          Swal.fire({
            title: res?.data?.heading ? res?.data?.heading : 'Error',
            text: res?.data?.message,
            showDenyButton: false,
            showCancelButton: false,
            icon: 'error',
            confirmButtonText: 'Close',
          }).then((result) => {
            if (result.isConfirmed) {
            } else if (result.isDenied) {
              return;
            }
          });
        }
      })
      .catch(() => {
        setContractAppLoader(false);
        setSharewinner(false);
        setBuyerRegisterCheckBox([]);
        setSelectedBuyerIdsForShare([]); // Clear the saved IDs
        Swal.fire({
          title: 'Error',
          text: 'Try again later',
          showDenyButton: false,
          showCancelButton: false,
          icon: 'error',
          confirmButtonText: 'Close',
        }).then((result) => {
          if (result.isConfirmed) {
          } else if (result.isDenied) {
            return;
          }
        });
      });
  };
  const handleClicke = (event) => {
    if (matchessm) {
      setDrawerOpen((prev) => !prev);
    } else {
      if (anchorEl) {
        setAnchorEl(null);
      } else {
        setAnchorEl(event.currentTarget);
      }
    }
  };

  const handleClosee = (event, reason) => {
    setAnchorEl(null);
    setBuyerRegisterCheckBox([]);
    setBuyerRegisterChecked(false);
  };

  const isForwardCounterOfferDisabled = () => {
    if (buyerRegisterCheckBox?.length < 2) return true;
    if (latestcounterOfferPrice == '$0') return true;
    if (profileData?.PropertyDetails?.stage === 'ST2') return true;

    let hasEligibleBuyer = false;

    for (let i = 0; i < buyerRegisterCheckBox.length; i++) {
      const buyerId = buyerRegisterCheckBox[i];

      const buyerData = tableData?.find(
        (item) => item?.buyerDetails?.user?.userId === buyerId
      );

      if (
        buyerData &&
        buyerData.buyerOfferDetails &&
        buyerData.buyerOfferDetails !== ''
      ) {
        const offerDetails = buyerData.buyerOfferDetails;
        const isAlreadyForwarded = offerDetails.counterOfferBuyerId?.length > 0;
        const isAcceptedByBuyer =
          offerDetails.offerStatusCode === 'BuyerAcc001' ||
          offerDetails.offerStatusCode === 'BuyerAccPrivate001';
        const hasValidOffer = buyerData.buyerOfferPrice > 0;

        if (!isAlreadyForwarded && !isAcceptedByBuyer && hasValidOffer) {
          hasEligibleBuyer = true;
          break;
        }
      }
    }

    return !hasEligibleBuyer;
  };
  const openn = Boolean(anchorEl);
  const id = openn ? 'simple-popover' : undefined;

  const [uploadDoc, setUploadDoc] = useState(true);

  const handleToggle = () => {
    setUploadDoc(!uploadDoc);
    setAmendMedia([]);
    setContractMedia([]);
  };
  const [toggleState, setToggleState] = useState(true);

  const handleToggleState = () => {
    setToggleState((prev) => !prev);
  };

  const [accountcopied, setAccountCopied] = useState(false);

  const handleAccountCopy = () => {
    navigator.clipboard.writeText('AJ Real Estate Trust Account');
    setAccountCopied(true);

    setTimeout(() => {
      setAccountCopied(false);
    }, 2000);
  };

  const [bsbcopied, setBsbCopied] = useState(false);

  const handleBsbCopy = () => {
    navigator.clipboard.writeText('019 1928');
    setBsbCopied(true);

    setTimeout(() => {
      setBsbCopied(false);
    }, 2000);
  };

  const [accnocopied, setAccNoCopied] = useState(false);

  const handleAccNoCopy = () => {
    navigator.clipboard.writeText('0190 21928');
    setAccNoCopied(true);

    setTimeout(() => {
      setAccNoCopied(false);
    }, 2000);
  };

  useEffect(() => {
    if (loading || contractAppLoader || shareMarketPlaceLoader) {
      document.body.style.pointerEvents = 'none';
      document.body.style.overflow = 'hidden';
    } else {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    }

    return () => {
      document.body.style.pointerEvents = 'auto';
      document.body.style.overflow = 'auto';
    };
  }, [loading, contractAppLoader, shareMarketPlaceLoader]);

  const [openFinalContractDialog, setOpenFinalContractDialog] = useState(false);
  const [openUploadDialog, setOpenUploadDialog] = useState(false);
  const [openPrepareDialog, setOpenPrepareDialog] = useState(false);
  const [uploadedPdf, setUploadedPdf] = useState(null);
  const [uploadedContractUrl, setUploadedContractUrl] = useState(null);

  const handleOpenFinalContractDialog = () => {
    setOpenFinalContractDialog(true);
  };

  const handleCloseFinalContractDialog = () => {
    setOpenFinalContractDialog(false);
  };

  const handleFinalContractSubmit = async (file) => {
    setUploadedPdf(file);
    setOpenUploadDialog(false);
    setOpenPrepareDialog(true);
    try {
      const formData = new FormData();
      formData.append('propertyId', params?.dashboardId);
      formData.append('vendorId', 0);
      formData.append('buyerId', props?.buyerId);
      formData.append('contractFile', file.file || file);
      const response = await postApiCall(CONTRACT_FILE_UPLOAD, formData);
      if (response?.data?.status === 1) {
        setUploadedContractUrl(response.data.contractFile);
      }
    } catch (error) {}
  };

  const handleClosePrepareDialog = () => {
    setOpenPrepareDialog(false);
  };

  const handleCloseAllContractDialogs = () => {
    setOpenPrepareDialog(false);
    setOpenFinalContractDialog(false);
  };

  const [openViewDialog, setOpenViewDialog] = useState(false);
  const handleOpenView = () => {
    setOpenViewDialog(true);
  };

  const handleCloseView = () => {
    setOpenViewDialog(false);
  };

  return (
    <Grid item style={{ cursor: 'pointer' }}>
      <Typography aria-describedby={id} onClick={handleClicke}>
        {openn ? <CloseIcon /> : <OpenIcon />}
      </Typography>
      <Popover
        id={id}
        open={openn}
        anchorEl={anchorEl}
        onClose={handleClosee}
        PaperProps={{
          style: { boxShadow: 'none', border: '1px solid #D9D9D9' },
        }}
        anchorOrigin={{
          vertical: 'top',
          horizontal: matchesmd ? 'left' : 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: matchesmd ? 'right' : 'left',
        }}
      >
        {!OfferCard && (
          <>
            <MenuItem
              value={20}
              sx={{ minHeight: matchessm ? '0px' : '', cursor: 'default' }}
              disableRipple
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#8E8A8A',
                  fontStyle: 'normal',
                }}
              >
                - Action for {row?.buyerDetails?.user?.userName}{' '}
                {row?.buyerDetails?.user?.userSurName} -
              </Typography>
            </MenuItem>
            <MenuItem
              value={30}
              disabled
              sx={{ minHeight: matchessm ? '0px' : '' }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Invite /> Meeting Invite
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              value={33}
              onClick={() => {
                setAnchorEl(null);
                manageOfferClick();
              }}
              disabled={buyerRegisterCheckBox?.length > 1}
              sx={{ minHeight: matchessm ? '0px' : '' }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Offer /> Manage Offer
              </Typography>
            </MenuItem>

            <MenuItem
              value={40}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              onClick={() => {
                setOpenBox(!openBox);
                setOfferUniqueId(row?.buyerOfferDetails?.offerUniqueId);
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setbuyerOfferPrice(row?.buyerOfferDetails?.offerPrice);
                setOfferHistory(row?.buyerOfferDetails?.offerHistory);
                manageOfferClickClose();
              }}
              disabled={
                !(
                  row?.buyerOfferDetails?.offerStatus == 'Offer Received' &&
                  !row?.buyerOfferDetails?.offerStatusVendor
                ) ||
                !row?.buyerOfferDetails?.offerPrice ||
                buyerRegisterCheckBox?.length > 1 ||
                propertyDetails?.PropertyDetails?.timerStatus === 'End' ||
                propertyDetails?.PropertyDetails?.timerStatus === 'Pause'
              }
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <ForwardOff /> Forward Offer to Vendor
              </Typography>
            </MenuItem>
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={
                !row?.buyerOfferDetails?.offerPrice ||
                row?.buyerOfferDetails?.offerStatus != 'Counter Offer' ||
                row?.buyerOfferDetails?.offerStatusVendor == 'Buyer Notified' ||
                buyerRegisterCheckBox?.length > 1 ||
                profileData?.PropertyDetails?.stage == 'ST2'
              }
              onClick={() => {
                setForwardCountertobuyer(true);
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setbuyerOfferPrice(row?.buyerOfferDetails?.offerPrice);
                handleClosee();
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <ForwardOffGray /> Forward Counter Offer
              </Typography>
            </MenuItem>
            <MenuItem
              value={50}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={
                !row?.buyerDetails?.buyerOffer?.offerPrice ||
                row?.buyerOfferDetails?.isMarket == 1 ||
                buyerRegisterCheckBox?.length > 1 ||
                isDisabled ||
                propertyDetails?.BuyerRegisterDetailsCount == 1 ||
                profileData?.PropertyDetails?.timerStatus === 'End' ||
                profileData?.PropertyDetails?.timerStatus === 'Pause'
              }
              onClick={() => {
                setForwardtobuyer(!forwardtobuyer);
                setbuyerOfferPrice(row?.buyerOfferDetails?.offerPrice);
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setSelectedrowbuyerid(row?.buyerDetails?.user?.userId);
                setOfferUniqueId(row?.buyerOfferDetails?.offerUniqueId);
                setTableChecked(!tableChecked);
                manageOfferClickClose();
                handleClosee();
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '6px',
                }}
              >
                <Share /> Share Offer with Buyers
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              sx={{ minHeight: matchessm ? '0px' : '' }}
              value={60}
              onClick={() => {
                setbuyerOfferPrice(row?.buyerOfferDetails?.offerPrice);
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setShareMarketPlace(true);
                manageOfferClickClose();
              }}
              disabled={
                !row?.buyerOfferDetails?.offerPrice ||
                tableData?.PropertyDetails?.stage == 'ST2' ||
                row?.buyerOfferDetails?.isMarket == 1 ||
                buyerRegisterCheckBox?.length > 1 ||
                profileData?.PropertyDetails?.timerStatus === 'End' ||
                profileData?.PropertyDetails?.timerStatus === 'Pause'
              }
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Hotspot /> Share Offer with Marketplace
              </Typography>
            </MenuItem>
            <MenuItem
              sx={{ minHeight: matchessm ? '0px' : '' }}
              value={60}
              onClick={() => {
                manageOfferClickClose();
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                OpenContactApprove();
              }}
              disabled={
                (profileData?.PropertyDetails?.timerStatus !== 'End' &&
                  row?.isContractViewed === 0) ||
                buyerRegisterCheckBox?.length > 1 ||
                profileData?.PropertyDetails?.isArchived === 1
              }
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Confirm /> Confirm Updated Contract
              </Typography>
            </MenuItem>

            <MenuItem
              sx={{ minHeight: matchessm ? '0px' : '', marginLeft: '3px' }}
              value={60}
              disabled={
                !(
                  profileData?.PropertyDetails?.isWinner == 0 &&
                  profileData?.PropertyDetails?.stage == 'ST2' &&
                  row?.isStageTwo == 0 &&
                  profileData?.PropertyDetails?.timerStatus !== 'End'
                ) ||
                buyerRegisterCheckBox?.length > 1 ||
                (profileData?.stageTwoCondition?.UnconditionalOnly == '1' &&
                  row?.logWData == 0)
              }
              onClick={() => {
                manageOfferClickClose();
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setOfferUniqueId(row?.buyerOfferDetails?.offerUniqueId);
                setSelectedrowbuyerid(row?.buyerDetails?.user?.userId);
                setAddbuyer(true);
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <BuyerFound /> Invite buyer to Stage 2
              </Typography>
            </MenuItem>

            {row?.signedContractFile == null ? (
              <MenuItem
                sx={{ minHeight: matchessm ? '0px' : '', marginLeft: '3px' }}
                value={60}
                disabled={
                  !row?.buyerOfferDetails?.offerPrice ||
                  buyerRegisterCheckBox?.length > 1 ||
                  propertyDetails?.PropertyDetails?.isArchived == 1
                }
                onClick={() => {
                  setSelectedBuyerId(row?.buyerDetails?.user?.userId);
                  openMessage(
                    row?.buyerDetails?.user?.userId,
                    params?.dashboardId
                  );
                  handleClosee();
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 300,
                    fontSize: '14px',
                    color: '#2F3F5E',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: -1,
                  }}
                >
                  <SignContract /> Initiate Sign Request
                  {initiateSignloading && (
                    <Typography sx={{ paddingLeft: '10px' }}>
                      <img
                        alt="Loading"
                        src={Loading}
                        className="loaderImage"
                        style={{ height: '25px', width: '25px' }}
                      />
                    </Typography>
                  )}
                </Typography>
              </MenuItem>
            ) : (
              <MenuItem
                sx={{ minHeight: matchessm ? '0px' : '', marginLeft: '3px' }}
                value={60}
                onClick={() => {
                  setSelectedBuyerId(row?.buyerDetails?.user?.userId);
                  handleClosee();
                  handleOpenView();
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 300,
                    fontSize: '14px',
                    color: '#2F3F5E',
                    display: 'flex',
                    alignItems: 'center',
                    marginLeft: -1,
                  }}
                >
                  <SignContract /> View Signed Contract
                </Typography>
              </MenuItem>
            )}

            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '', marginLeft: '-2px' }}
              disabled={
                profileData?.PropertyDetails?.isWinner == 1 ||
                !row?.buyerOfferDetails?.offerPrice ||
                (profileData?.PropertyDetails?.stage == 'ST1' &&
                  row?.buyerOfferDetails?.offerStatus != 'Accepted' &&
                  row?.isApprovedLog != 1) ||
                buyerRegisterCheckBox?.length > 1 ||
                profileData?.PropertyDetails?.timerStatus === 'Pause'
              }
              onClick={() => {
                manageOfferClickClose();
                setOfferUniqueId(row?.buyerOfferDetails?.offerUniqueId);
                setPaymentStatus(row);
                setManageofferrow(row);
                setOpenPublishWinnerBox(true);
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setSelectedrowbuyerid(row?.buyerDetails?.user?.userId);
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '7px',
                }}
              >
                <Winner /> Nominate Winner
              </Typography>
            </MenuItem>
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={
                row?.buyerOfferDetails?.offerPrice == null ||
                buyerRegisterCheckBox?.length > 1
              }
              onClick={() => {
                manageOfferClickClose();
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setbuyerOfferPrice(row?.buyerOfferDetails?.offerPrice);
                setSelectedrowbuyerid(row?.buyerDetails?.user?.userId);
                if (row?.isDepositReceived == 1) {
                  setDepositdetails(true);
                } else {
                  setRequestdeposit(true);
                }
                setDepositRes(row?.buyerOfferDetails?.depositPaymentLog);
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                {row?.isDepositReceived == 1 ? <RequestIcon /> : <Deposit />}{' '}
                {row?.isDepositReceived == 1
                  ? 'Deposit Manager'
                  : 'Request Deposit'}
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '', cursor: 'default' }}
              disableRipple
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 400,
                  fontSize: '12px',
                  color: '#8E8A8A',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                }}
              >
                - Action for Multi Selected -
              </Typography>
            </MenuItem>
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={
                buyerRegisterCheckBox?.length >= 2 &&
                buyerRegisterCheckBox?.includes(props?.buyerId)
                  ? false
                  : true
              }
              onClick={(e) => {
                manageOfferClickClose();
                for (
                  let index = 0;
                  index < buyerRegisterCheckBoxArr.length;
                  index++
                ) {
                  const element = buyerRegisterCheckBoxArr[index];
                  handleClick(
                    true,
                    index,
                    buyerRegisterCheckBoxArr[index]?.buyerDetails?.user?.userId,
                    buyerRegisterCheckBoxArr[index],
                    buyerRegisterCheckBoxArr[index]?.buyerDetails?.userCategory,
                    setShowBackDrop(true)
                  );
                }
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Compare /> Compare
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={
                buyerRegisterCheckBox?.length >= 2 &&
                buyerRegisterCheckBox?.includes(props?.buyerId)
                  ? false
                  : true
              }
            >
              <Typography
                onClick={() => {
                  setBroadcastMessage(true);
                  handleClosee();
                }}
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <Message /> Broadcast Message
              </Typography>
            </MenuItem>

            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={isForwardCounterOfferDisabled()}
              onClick={() => {
                setForwardCountertobuyer(true);
                setMultipleChkCounter(true);
                setAnchorEl(null);
                setSelectedrowbuyername(
                  row?.buyerDetails?.user?.userName +
                    ' ' +
                    row?.buyerDetails?.user?.userSurName
                );
                setbuyerOfferPrice(row?.buyerOfferDetails?.offerPrice);
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '8px',
                }}
              >
                <ForwardOffGray /> Forward Counter Offer
              </Typography>
            </MenuItem>
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              disabled={
                buyerRegisterCheckBox?.length < 2 ||
                !buyerRegisterCheckBox?.includes(props?.buyerId) ||
                profileData?.PropertyDetails?.isWinner == 0
              }
              onClick={() => {
                // Save the current selected buyer IDs
                setSelectedBuyerIdsForShare([...buyerRegisterCheckBox]);
                // Show the confirmation popup
                setSharewinner(true);
                // Close the menu
                handleClosee();
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <Winner /> Share Winner
              </Typography>
            </MenuItem>
            <Divider />
            <MenuItem
              value={60}
              sx={{ minHeight: matchessm ? '0px' : '' }}
              onClick={() => {
                handleClosee();
                history.push('/helpcentre');
              }}
            >
              <Typography
                sx={{
                  fontFamily: 'Poppins!important',
                  fontWeight: 300,
                  fontSize: '14px',
                  color: '#2F3F5E',
                  fontStyle: 'normal',
                  display: 'flex',
                  alignItems: 'center',
                  gap: '5px',
                }}
              >
                <NeedHelp /> Need Help?
              </Typography>
            </MenuItem>
          </>
        )}
        {OfferCard && (
          <>
            {!UserType == 'Agent' && (
              <MenuItem value={61}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#8E8A8A',
                    lineHeight: 'normal',
                    fontStyle: 'normal',
                  }}
                >
                  <Compare /> Twenty
                </Typography>
              </MenuItem>
            )}
            {!UserType == 'Agent' && (
              <MenuItem value={62}>
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#8E8A8A',
                    lineHeight: 'normal',
                    fontStyle: 'normal',
                  }}
                >
                  <Compare /> Thirty
                </Typography>
              </MenuItem>
            )}

            {UserType == 'Agent' && (
              <MenuItem
                value={62}
                disabled={isAppraisalProperty}
                onClick={onPropertyClick}
                sx={{ minHeight: matchessm ? '0px' : '' }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#2F3F5E',
                    lineHeight: 'normal',
                    fontStyle: 'normal',
                  }}
                >
                  View listing
                </Typography>
              </MenuItem>
            )}
            {UserType == 'Agent' && !isUnPublished && (
              <MenuItem
                value={62}
                onClick={onDownload}
                disabled={
                  isAppraisalProperty
                    ? isAppraisalProperty
                    : item?.property?.status == 'Unpublish'
                }
                sx={{ minHeight: matchessm ? '0px' : '' }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#2F3F5E',
                    lineHeight: 'normal',
                    fontStyle: 'normal',
                  }}
                >
                  Generate Vendor Report
                </Typography>
              </MenuItem>
            )}
            {UserType == 'Agent' && (
              <MenuItem
                value={62}
                disabled={isAppraisalProperty}
                onClick={(e) => {
                  setNotificationAnchorEl(anchorEl || e.currentTarget);
                  setOpenNotificationSettingPopup(true);
                  setAnchorEl(null);
                }}
                sx={{ minHeight: matchessm ? '0px' : '' }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#2F3F5E',
                    lineHeight: 'normal',
                    fontStyle: 'normal',
                  }}
                >
                  Notification settings
                </Typography>
              </MenuItem>
            )}
            {UserType == 'Agent' && (
              <MenuItem
                value={62}
                disabled={isAppraisalProperty}
                onClick={onPropertyClick}
                sx={{ minHeight: matchessm ? '0px' : '' }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins!important',
                    fontWeight: 400,
                    fontSize: '12px',
                    color: '#2F3F5E',
                    lineHeight: 'normal',
                    fontStyle: 'normal',
                  }}
                >
                  Campaign Settings
                </Typography>
              </MenuItem>
            )}
          </>
        )}
      </Popover>

      {/* Broadcast Message Popup - MOVED OUTSIDE OF POPOVER */}
      {openbroadcastMessage && (
        <BroadcastMessagepopup
          open={openbroadcastMessage}
          buyerRegisterCheckBoxArr={buyerRegisterCheckBoxArr}
          tableData={propertyDetails}
          onSend={handleSend}
          onClose={() => {
            setBroadcastMessage(false);
            setBuyerRegisterCheckBox([]);
            setBuyerRegisterCheckBoxArr([]);
            setTableChecked(false);
            setBuyerRegisterChecked(false);
          }}
          setBuyerRegisterCheckBox={setBuyerRegisterCheckBox}
          address={address}
        />
      )}

      {(manageOffer || openhistorydialog) && (
        <ManageOffer
          open={manageOffer}
          onClose={manageOfferClickClose}
          getListInfo={getListInfo}
          row={row}
          setOfferUniqueId={setOfferUniqueId}
          buyerId={props.buyerId}
          updatefunc={updatefunc}
          setManageOffer={setManageOffer}
          setOpenhistorydialog={setOpenhistorydialog}
          agentSubText={true}
          offerIsFinal={offerIsFinal}
          userTypeValue={userTypeValue}
          tableData={tableData?.BuyerRegisterDetails}
          onShowChat={onShowChat}
        />
      )}

      {/* Share Offer With Marketplace  Active Popup */}
      {shareMarketPlace && (
        <ShareOfferWithMarketPlace
          shareMarketPlace={shareMarketPlace}
          setShareMarketPlace={setShareMarketPlace}
          getListInfo={getListInfo}
          address={address}
          offerUniqueId={row?.buyerOfferDetails?.offerUniqueId}
          selectedrowbuyername={selectedrowbuyername}
          buyerOfferPrice={buyerOfferPrice}
        />
      )}

      {/* Add buyer to Stage Two Active Popup */}

      <Dialog
        open={addbuyer}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Pendingwarning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Invite buyer to Stage 2
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            sm={12}
            md={12}
            textAlign={'left'}
            paddingTop={'10px'}
          >
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                color: '#666666',
              }}
            >
              Would you like to invite buyer {selectedrowbuyername} to Stage 2
              of the campaign?
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={shareMarketPlaceLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => setAddbuyer(false)}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={shareMarketPlaceLoader}
                variant="outlined"
                onClick={addbuyerfunc}
                style={{
                  padding: '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '14px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Invite
              </Button>
              {shareMarketPlaceLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      {/* Confirm Updated Contract Active Popup */}

      <Dialog
        open={contractAprove}
        fullScreen={matches700}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            width: '100%',
            maxWidth: '895px',
            paddingBottom: matches700 && '40px',
            '& .MuiDialogContent-root': {
              overflow: 'visible',
            },
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid
            container
            sx={{
              display: 'flex',
              flexDirection: 'column',
              padding: matches700 ? '10px' : '30px',
              gap: '20px',
            }}
          >
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '10px' : '14px',
                  color: '#666666',
                }}
              >
                {address}
              </Typography>
            </Grid>
            <Grid
              item
              sx={{ display: 'flex', flexDirection: 'row', gap: '10px' }}
            >
              <Pendingwarning />
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '16px' : '24px',
                }}
              >
                Confirm Updated Contract
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                retreX has not received an updated contract for{' '}
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {selectedrowbuyername}
                </b>
              </Typography>
            </Grid>
            <Grid item>
              <Typography
                sx={{
                  fontFamily: 'poppins',
                  fontWeight: 400,
                  fontSize: matchessm ? '12px' : '16px',
                  color: '#666666',
                }}
              >
                Please confirm you have received an updated contract and or
                agreed amendments for{' '}
                <b
                  style={{
                    fontFamily: 'Poppins',
                    fontWeight: 550,
                    color: '#666666',
                  }}
                >
                  {selectedrowbuyername}
                </b>
                . Once confirmed you will be able to send an E-Sign request to
                the Buyer.
              </Typography>
            </Grid>
          </Grid>

          <Box sx={{ borderTop: '1px solid lightgrey', width: '100%' }} />

          <Grid
            item
            container
            xs={12}
            sm={12}
            xl={12}
            sx={{
              padding: matches700 ? '10px' : '30px',
            }}
          >
            <Grid
              container
              xs={5}
              sm={4}
              xl={4}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap: '50px',
                justifyContent: 'center',
              }}
            >
              <Grid
                item
                sx={{
                  display: 'flex',
                  alignItems: 'center',
                  justifyContent: 'space-between',
                  width: '100%',
                  gap: '30px',
                }}
              >
                <Typography
                  sx={{
                    fontFamily: 'Poppins',
                    fontSize: { md: '16px', xs: '12px' },
                    fontWeight: 400,
                    color: '#666666',
                    wordWrap: 'break-word',
                  }}
                >
                  Upload Legal Documents
                </Typography>
              </Grid>
              {uploadDoc && (
                <>
                  <Grid item>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { md: '16px', xs: '12px' },
                        fontWeight: 400,
                        color: '#666666',
                      }}
                    >
                      Amendments
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { md: '16px', xs: '12px' },
                        fontWeight: 400,
                        color: '#666666',
                      }}
                    >
                      Contract of Sale{' '}
                      <span style={{ color: 'red', fontSize: '20px' }}>*</span>
                    </Typography>
                  </Grid>
                </>
              )}
            </Grid>

            <Grid
              xs={7}
              sm={8}
              xl={8}
              sx={{
                display: 'flex',
                flexDirection: 'column',
                gap:
                  errorAmendMessage && errorContractMessage
                    ? '10px'
                    : errorAmendMessage || errorContractMessage
                    ? '20px'
                    : '30px',
                justifyContent: matchessm ? 'center' : '',
                alignItems: matchessm ? 'center' : '',
              }}
            >
              <Grid item>
                <Stack direction="row" alignItems="center" spacing={2}>
                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '10px',
                      color: uploadDoc ? '#112347' : '#9C9C9C',
                    }}
                  >
                    No
                  </Typography>

                  <Typography
                    onClick={handleToggle}
                    sx={{
                      cursor: 'pointer',
                    }}
                  >
                    {uploadDoc ? (
                      <ToggleOn color="primary" />
                    ) : (
                      <ToggleOff color="disabled" />
                    )}
                  </Typography>

                  <Typography
                    sx={{
                      ...poppins400,
                      fontSize: '10px',
                      color: uploadDoc ? '#9C9C9C' : '#112347',
                    }}
                  >
                    Yes
                  </Typography>
                </Stack>
              </Grid>
              {uploadDoc && (
                <>
                  <Grid item>
                    <button
                      style={{
                        height: '41px',
                        padding: matches700 ? '10px 30px' : '20px 50px',
                        borderRadius: '5px',
                        backgroundColor: '#6C2AD2',
                        color: '#FFFFFF',
                        border: 'none',
                        cursor: 'pointer',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: '400',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      onClick={() =>
                        document.getElementById('amend-file-upload').click()
                      }
                    >
                      Upload
                    </button>

                    <input
                      type="file"
                      id="amend-file-upload"
                      style={{ display: 'none' }}
                      multiple
                      accept="application/pdf"
                      onChange={(e) => handleAmendFileUpload(e)}
                    />
                  </Grid>
                  <Grid item>
                    <button
                      style={{
                        height: '41px',
                        padding: matches700 ? '10px 30px' : '20px 50px',
                        borderRadius: '5px',
                        backgroundColor: '#6C2AD2',
                        color: '#FFFFFF',
                        border: 'none',
                        cursor: 'pointer',
                        fontFamily: 'poppins',
                        fontSize: '14px',
                        fontWeight: '400',
                        textAlign: 'center',
                        display: 'flex',
                        alignItems: 'center',
                        justifyContent: 'center',
                      }}
                      onClick={() =>
                        document.getElementById('contract-file-upload').click()
                      }
                    >
                      Upload
                    </button>
                    {errorContractMessage && (
                      <span
                        style={{
                          color: 'red',
                          fontFamily: 'Poppins',
                          fontSize: '12px',
                        }}
                      >
                        {errorContractMessage}
                      </span>
                    )}
                    <input
                      type="file"
                      id="contract-file-upload"
                      style={{ display: 'none' }}
                      accept="application/pdf"
                      onChange={(e) => handleContractFileUpload(e)}
                    />
                  </Grid>
                </>
              )}
            </Grid>
            {uploadDoc && (
              <>
                <Grid
                  item
                  container
                  xs={12}
                  sm={12}
                  xl={12}
                  sx={{
                    padding: '30px 0px 30px 0px',
                  }}
                >
                  {(amendMedia.length > 0 || contractMedia.length > 0) && (
                    <TableContainer component={Paper}>
                      <Table
                        sx={{ minWidth: '100%' }}
                        aria-label="uploaded files table"
                      >
                        <TableHead>
                          <TableRow>
                            <TableCell
                              sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                            >
                              S No
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                            >
                              Date Uploaded
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                            >
                              Document Type
                            </TableCell>
                            <TableCell
                              align="center"
                              sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                            >
                              Document Name
                            </TableCell>
                            <TableCell
                              sx={{ fontSize: '14px', fontFamily: 'poppins' }}
                            >
                              Remove
                            </TableCell>
                          </TableRow>
                        </TableHead>
                        <TableBody>
                          {[...amendMedia, ...contractMedia].map(
                            (file, index) => {
                              const sydneyDate = dayjs()
                                .tz('Australia/Sydney')
                                .format('DD-MM-YYYY');
                              return (
                                <TableRow
                                  key={file.id}
                                  sx={{
                                    '&:last-child td, &:last-child th': {
                                      border: 0,
                                    },
                                  }}
                                >
                                  <TableCell
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    {index + 1}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    {sydneyDate}
                                  </TableCell>
                                  <TableCell
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    {file.category}
                                  </TableCell>
                                  <TableCell
                                    align="center"
                                    sx={{
                                      fontSize: '12px',
                                      fontFamily: 'poppins',
                                    }}
                                  >
                                    <Box
                                      sx={{
                                        display: 'flex',
                                        flexDirection: 'column',
                                        alignItems: 'center',
                                        justifyContent: 'center',
                                        gap: '6px',
                                        width: '100%',
                                        padding: '4px',
                                      }}
                                    >
                                      <img
                                        src={PdfIcon}
                                        style={{
                                          width: '48px',
                                          height: 'auto',
                                          flexShrink: 0,
                                        }}
                                        alt="pdficon"
                                      />
                                      <span
                                        style={{
                                          fontFamily: 'poppins',
                                          textAlign: 'center',
                                          fontSize: '11px',
                                          lineHeight: '1.2',
                                          maxWidth: '100px',
                                          wordBreak: 'break-word',
                                        }}
                                      >
                                        {getFileNameParts(file.name).base}
                                        <span
                                          style={{
                                            whiteSpace: 'nowrap', // ✅ prevents ".pdf" from breaking
                                            display: 'inline-block',
                                          }}
                                        >
                                          {getFileNameParts(file.name).ext}
                                        </span>
                                      </span>
                                    </Box>
                                  </TableCell>
                                  <TableCell>
                                    <IconButton
                                      onClick={() => handleDeleteFile(file)}
                                    >
                                      <ClearIcon />
                                    </IconButton>
                                  </TableCell>
                                </TableRow>
                              );
                            }
                          )}
                        </TableBody>
                      </Table>
                    </TableContainer>
                  )}
                </Grid>

                <Grid xs={4} sm={3} xl={2} sx={{ display: 'flex' }}>
                  <Grid item sx={{ mt: '8px' }}>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { md: '16px', xs: '12px' },
                        fontWeight: 400,
                        color: '#666666',
                      }}
                    >
                      Reviewed by
                    </Typography>
                  </Grid>
                </Grid>

                <Grid xs={8} sm={9} xl={10} sx={{ display: 'flex' }}>
                  <Grid item>
                    <Stack
                      direction="row"
                      alignItems="center"
                      spacing={2}
                      sx={{ gap: '5px' }}
                    >
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: '10px',
                        }}
                      >
                        Self
                      </Typography>

                      <IconButton onClick={() => setToggle(!toggle)}>
                        {!toggle ? <ToggleOff /> : <ToggleOn />}
                      </IconButton>
                      <Typography
                        sx={{
                          ...poppins400,
                          fontSize: '10px',
                        }}
                      >
                        Legal Representative
                      </Typography>
                    </Stack>
                  </Grid>
                </Grid>
              </>
            )}
          </Grid>
          {toggle && (
            <>
              <Grid
                item
                sx={{ display: 'flex', padding: matches700 ? '10px' : '30px' }}
              >
                <Typography
                  sx={{
                    fontFamily: 'poppins',
                    fontWeight: 400,
                    fontSize: matchessm ? '16px' : '24px',
                  }}
                >
                  Legal Representative
                </Typography>
              </Grid>

              <Grid
                item
                container
                xs={12}
                sm={12}
                xl={12}
                sx={{
                  padding: matches700 ? '10px' : '30px',
                }}
              >
                <Grid
                  xs={4}
                  sm={3}
                  xl={2}
                  sx={{ display: 'flex', flexDirection: 'column', gap: '60px' }}
                >
                  <Grid item>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { md: '16px', xs: '12px' },
                        fontWeight: 400,
                        color: '#666666',
                      }}
                    >
                      First Name:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { md: '16px', xs: '12px' },
                        fontWeight: 400,
                        color: '#666666',
                      }}
                    >
                      Last Name:
                    </Typography>
                  </Grid>
                  <Grid item>
                    <Typography
                      sx={{
                        fontFamily: 'Poppins',
                        fontSize: { md: '16px', xs: '12px' },
                        fontWeight: 400,
                        color: '#666666',
                      }}
                    >
                      Email:
                    </Typography>
                  </Grid>
                </Grid>

                <Grid
                  xs={8}
                  sm={9}
                  xl={10}
                  sx={{ display: 'flex', flexDirection: 'column', gap: '20px' }}
                >
                  <Grid item>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <TextField
                        variant="outlined"
                        error={firstVal}
                        value={capitalize(firstName)}
                        onChange={(event) => {
                          setFirstName(event.target.value);
                          setFirstVal(false);
                        }}
                        inputProps={{
                          maxLength: 30,
                          style: { fontFamily: 'poppins' },
                        }}
                        placeholder="First Name"
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: { md: '16px', xs: '12px' },
                          fontWeight: 400,
                          color: '#666666',
                          '& .MuiInputBase-input': {
                            padding: '8px',
                            color: '#666666',
                            fontFamily: 'Poppins',
                          },
                          '& .MuiOutlinedInput-root': {
                            color: '#666666',
                            fontFamily: 'Poppins',
                          },
                        }}
                      />
                      <span
                        style={{
                          color: 'red',
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          marginTop: '4px',
                          visibility: firstVal ? 'visible' : 'hidden',
                        }}
                      >
                        Enter your first name
                      </span>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <TextField
                        variant="outlined"
                        value={capitalize(lastName)}
                        error={lastVal}
                        onChange={(event) => {
                          setLastName(event.target.value);
                          setLastVal(false);
                        }}
                        inputProps={{
                          maxLength: 30,
                          style: { fontFamily: 'poppins' },
                        }}
                        placeholder="Last Name"
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: { md: '16px', xs: '12px' },
                          fontWeight: 400,
                          color: '#666666',
                          '& .MuiInputBase-input': {
                            padding: '8px',
                            color: '#666666',
                            fontFamily: 'Poppins',
                          },
                          '& .MuiOutlinedInput-root': {
                            color: '#666666',
                            fontFamily: 'Poppins',
                          },
                        }}
                      />
                      <span
                        style={{
                          color: 'red',
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          marginTop: '4px',
                          visibility: lastVal ? 'visible' : 'hidden',
                        }}
                      >
                        Enter your last name
                      </span>
                    </Box>
                  </Grid>
                  <Grid item>
                    <Box sx={{ display: 'flex', flexDirection: 'column' }}>
                      <TextField
                        variant="outlined"
                        value={email}
                        error={emailVal}
                        onChange={(event) => handleEmail(event)}
                        placeholder="cedeto4643@idsho.com"
                        sx={{
                          fontFamily: 'Poppins',
                          fontSize: { md: '16px', xs: '12px' },
                          fontWeight: 400,
                          color: '#666666',
                          '& .MuiInputBase-input': {
                            padding: '8px',
                            color: '#666666',
                            fontFamily: 'Poppins',
                          },
                          '& .MuiOutlinedInput-root': {
                            color: '#666666',
                            fontFamily: 'Poppins',
                          },
                        }}
                      />
                      <span
                        style={{
                          color: 'red',
                          fontFamily: 'poppins',
                          fontSize: '12px',
                          marginTop: '4px',
                          visibility: errorMessage
                            ? 'visible'
                            : emailVal
                            ? 'visible'
                            : 'hidden',
                        }}
                      >
                        {errorMessage ? errorMessage : 'Enter your email'}
                      </span>
                    </Box>
                  </Grid>
                </Grid>
              </Grid>
            </>
          )}

          <Grid
            item
            container
            sx={{
              padding: matches900
                ? '10px 30px 10px 30px'
                : '40px 30px 20px 120px',
              display: 'flex',
              flexDirection: 'row',
              justifyContent: 'flex-end',
              gap: '30px',
            }}
          >
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => setContractAprove(false)}
                disabled={loading}
              >
                Cancel
              </Button>
            </Grid>
            <Grid item>
              <Button
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 30px' : '10px 50px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={uploadDoc ? uploadDocumentValidate : UpdatedContract}
                disabled={loading}
              >
                Submit
              </Button>
            </Grid>
            {loading && (
              <Grid>
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              </Grid>
            )}
          </Grid>
        </Grid>
      </Dialog>

      {/* Share Winner Active Popup */}

      <Dialog
        open={sharewinner}
        PaperProps={{
          sx: {
            borderRadius: '5px',
            minWidth: matchessm ? '95%' : '400px',
            boxShadow: ' -4px, 4px rgba(0, 0, 0, 0.09)',
            padding: matchessm ? '30px 20px' : '30px',
          },
        }}
      >
        <Grid container height={'100%'}>
          <Grid item xs={12}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '10px' : '14px',
                color: '#666666',
              }}
            >
              {'   '}
              {address}
              &nbsp;
            </Typography>
          </Grid>
          <Grid
            item
            xs={12}
            display={'flex'}
            alignItems={'center'}
            padding={'12px 0px 15px 0'}
          >
            <Warning />
            <Typography
              sx={{
                ...poppins500,
                fontSize: matchessm ? '16px' : '24px',
                paddingLeft: '12px',
              }}
            >
              Share Winner
            </Typography>
          </Grid>
          <Grid item textAlign={'left'} paddingTop={'10px'}>
            <Typography
              sx={{
                ...poppins400,
                fontSize: matchessm ? '12px' : '16px',
                width: 'auto',
                color: '#666666',
              }}
            >
              You have selected multiple buyers, this action will apply to all
              buyers selected
            </Typography>
          </Grid>

          <Grid
            item
            container
            direction="row"
            sx={{ display: 'flex', alignItems: 'center' }}
            justifyContent={'flex-end'}
            gap={2}
            marginTop={matchessm ? '15px' : 5}
          >
            <Grid item>
              <Button
                disabled={contractAppLoader}
                variant="outlined"
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#666666',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  border: '1px solid rgba(17, 35, 71, 0.1)',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
                onClick={() => {
                  setSharewinner(false);
                  setBuyerRegisterCheckBox([]);
                }}
              >
                Cancel
              </Button>
            </Grid>
            <Grid
              item
              sx={{
                position: 'relative',
                display: 'flex',
                alignItems: 'center',
              }}
            >
              <Button
                disabled={contractAppLoader}
                variant="outlined"
                onClick={Sharewinnerfunc}
                style={{
                  padding: matchessm ? '6px 23px' : '10px 39px',
                  width: '100%',
                  height: matchessm ? '35px' : '41px',
                  fontSize: matchessm ? '12px' : '15px',
                  color: '#FFFFFF',
                  fontWeight: '400',
                  fontFamily: 'Poppins',
                  background: '#4CA4D6',
                  borderRadius: '5px',
                  textTransform: 'none',
                }}
              >
                Share
              </Button>
              {contractAppLoader && (
                <img
                  alt="Logo"
                  src={Loading}
                  className="loaderImage"
                  style={{ height: '40px', width: '40px' }}
                />
              )}
            </Grid>
          </Grid>
        </Grid>
      </Dialog>

      {matchessm && (
        <ActionDrawer
          item={item}
          setBuyerRegisterChecked={setBuyerRegisterChecked}
          initiateSignloading={initiateSignloading}
          profileData={profileData}
          onDownload={onDownload}
          isUnPublished={isUnPublished}
          onPropertyClick={onPropertyClick}
          isAppraisalProperty={isAppraisalProperty}
          UserType={UserType}
          setSharewinner={setSharewinner}
          setMultipleChkCounter={setMultipleChkCounter}
          setBroadcastMessage={setBroadcastMessage}
          buyerRegisterCheckBoxArr={buyerRegisterCheckBoxArr}
          buyerId={props.buyerId}
          setShowBackDrop={setShowBackDrop}
          handleClick={handleClick}
          setDepositRes={setDepositRes}
          setRequestdeposit={setRequestdeposit}
          open={drawerOpen}
          setDrawerOpen={setDrawerOpen}
          OfferCard={OfferCard}
          buyerName={row?.buyerDetails?.user?.userName}
          buyerSurName={row?.buyerDetails?.user?.userSurName}
          row={row}
          manageOfferClick={manageOfferClick}
          setAnchorEl={setAnchorEl}
          buyerRegisterCheckBox={buyerRegisterCheckBox}
          openBox={openBox}
          setOpenBox={setOpenBox}
          setOfferUniqueId={setOfferUniqueId}
          setSelectedrowbuyername={setSelectedrowbuyername}
          manageOfferClickClose={manageOfferClickClose}
          setOfferHistory={setOfferHistory}
          setbuyerOfferPrice={setbuyerOfferPrice}
          tableChecked={tableChecked}
          setTableChecked={setTableChecked}
          setSelectedrowbuyerid={setSelectedrowbuyerid}
          forwardtobuyer={forwardtobuyer}
          setForwardtobuyer={setForwardtobuyer}
          isDisabled={isDisabled}
          openMessage={openMessage}
          setAddbuyer={setAddbuyer}
          tableData={tableData}
          OpenContactApprove={OpenContactApprove}
          setShareMarketPlace={setShareMarketPlace}
          setForwardCountertobuyer={setForwardCountertobuyer}
          setOpenPublishWinnerBox={setOpenPublishWinnerBox}
          openbroadcastMessage={openbroadcastMessage}
          handleSend={handleSend}
          setBuyerRegisterCheckBox={setBuyerRegisterCheckBox}
          latestcounterOfferPrice={latestcounterOfferPrice}
          setPaymentStatus={setPaymentStatus}
          mobileTableData={mobileTableData}
          setBuyerRegisterCheckBoxArr={setBuyerRegisterCheckBoxArr}
          address={address}
          setDepositdetails={setDepositdetails}
          handleOpenView={handleOpenView}
          isForwardCounterOfferDisabled={isForwardCounterOfferDisabled}
          setOpenNotificationSettingPopup={setOpenNotificationSettingPopup}
          setNotificationAnchorEl={setNotificationAnchorEl}
        />
      )}

      {forwardcountertobuyer && (
        <ForwardCounterOfferPopup
          open={forwardcountertobuyer}
          onClose={() => {
            setForwardCountertobuyer(false);
            getListInfo();
          }}
          multipleChkCounter={multipleChkCounter}
          selectedCheckboxes={selectedCheckboxes}
          setSelectedCheckboxes={setSelectedCheckboxes}
          setBuyerRegisterCheckBox={setBuyerRegisterCheckBox}
          setBuyerRegisterChecked={setBuyerRegisterChecked}
          offerPriceVendor={offerPriceVendor}
          formattedlatestcounterOfferPrice={formattedlatestcounterOfferPrice}
          formattedOfferPriceVendor={formattedOfferPriceVendor}
          selectedrowbuyername={selectedrowbuyername}
          mobileView={mobileView}
          propertyDetails={propertyDetails}
          counterOfferBuyerId={counterOfferBuyerId}
          offerUniqueId={offerUniqueId}
          setShareMarketPlace={setShareMarketPlace}
          sharedToMarket={sharedToMarket}
          {...props}
        />
      )}
      {requestdeposit && (
        <Requestdeposit
          requestdeposit={requestdeposit}
          endPropertyPopupFromNominateWinner={
            endPropertyPopupFromNominateWinner
          }
          manageOfferClick={manageOfferClick}
          setRequestdeposit={setRequestdeposit}
          setReqDepositOpen={setReqDepositOpen}
          selectedrowbuyerid={selectedrowbuyerid}
          getListInfo={getListInfo}
          selectedrowbuyername={selectedrowbuyername}
          row={row}
          reqDepositOpen={reqDepositOpen}
          address={address}
          depositRes={depositRes}
          setEndPropertyPopupFromNominateWinner={
            setEndPropertyPopupFromNominateWinner
          }
          profileDetails={profileData}
        />
      )}
      {depositdetails && (
        <DetailsPopup
          openDetailsPopup={depositdetails}
          handleCloseDetails={() => {
            setDepositdetails(false);
          }}
          profileDetails={profileData}
          buyerId={selectedrowbuyerid}
          isFromBuyerRegister={true}
          getListInfo={getListInfo}
          manageOfferClick={manageOfferClick}
        />
      )}
      {openFinalContractDialog && (
        <FinalContractUploadDialog
          open={openFinalContractDialog}
          onClose={handleCloseFinalContractDialog}
          onSubmit={handleFinalContractSubmit}
          streetName={
            propertyDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          matchessm={matchessm}
          buyerId={selectedBuyerId}
          userType={UserType}
          getListInfo={getListInfo}
        />
      )}
      {openPrepareDialog && (
        <PrepareContractSignDialog
          open={openPrepareDialog}
          onCancel={handleClosePrepareDialog}
          onSuccess={handleCloseAllContractDialogs}
          pdfFile={uploadedPdf}
          streetName={
            propertyDetails?.PropertyDetails?.propertyAddress?.streetName
          }
          matchessm={matchessm}
          contractFileUrl={uploadedContractUrl}
          propertyId={params.dashboardId}
          buyerId={props?.buyerId}
          userName={userName}
        />
      )}
      {openViewDialog && (
        <ViewCommenceEsignPdf
          open={openViewDialog}
          onClose={handleCloseView}
          taskPath={row?.signedContractFile}
          streetName={profileData?.PropertyDetails?.propertyAddress?.streetName}
          matchessm={matchessm}
          statusLastUpdatedAt={row?.signedContractAt}
          onInitiateEsign={handleOpenFinalContractDialog}
          primaryUserTypeValue={UserType}
          isArchived={profileData?.PropertyDetails?.isArchived === 1}
        />
      )}
      {openNotificationSettingPopup && (
        <ActionNotificationSettingPopup
          Id={id}
          anchorEl={notificationAnchorEl || anchorEl}
          open={openNotificationSettingPopup}
          onClose={() => {
            setOpenNotificationSettingPopup(false);
            setNotificationAnchorEl(null);
            setAnchorEl(null);
            setDrawerOpen(false);
          }}
          address={item?.propertyAddress?.streetName || ''}
          propertyId={item?.property?.propertyId}
        />
      )}
    </Grid>
  );
}
